import _regeneratorRuntime from "/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _assertThisInitialized from "/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/esm/inherits";
import { PureComponent, createElement, Fragment, Component, createContext, forwardRef, createRef } from 'react';
import cuid from 'cuid';
import Button from '@material-ui/core/Button';
import { FragmentAssembler, assemble } from '@vizstack/js';
import clsx from 'clsx';
import { createMuiTheme, withStyles, createStyles } from '@material-ui/core/styles';
import 'typeface-roboto-mono';
import 'typeface-ubuntu-mono';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Map as Map$1, List } from 'immutable';
import { fromSchema, StructuredStorage, StagedLayout, BasicOptimizer, generateSpringForcesCompound, generateCompactnessForces, constrainNodeOffset, constrainNodeNonoverlap, generateNodeChildrenConstraints, generateNodePortConstraints, Vector, OrthogonalRouter, toSchema } from 'nodal';
import ReactDOM from 'react-dom';
import { line, curveBasis } from 'd3';
import { parse } from 'svg-path-round-corners/dist/es6/parse';
import { serialize } from 'svg-path-round-corners/dist/es6/serialize';
import _ from 'lodash';
var fonts = {
  RobotoMono: '"Roboto Mono", monospace',
  UbuntuMono: '"Ubuntu Mono", monospace'
};
var LightTheme = {
  framed: {
    normal: {
      backgroundColor: 'transparent',
      border: '1px solid rgb(237, 237, 236)',
      borderLeftWidth: '3px',
      borderRadius: '4px',
      padding: 2
    },
    lowlight: {},
    highlight: {
      backgroundColor: 'rgba(30, 167, 253, 0.2)',
      borderLeftColor: 'rgba(30, 167, 253, 0.5)'
    },
    selected: {
      borderLeftColor: 'rgba(2, 122, 197, 0.5)'
    }
  },
  unframed: {
    normal: {
      backgroundColor: 'transparent',
      // borderLeftStyle: 'solid' as any,
      // borderLeftWidth: '2px',
      // borderLeftColor: 'transparent',
      borderRadius: '4px 0px',
      padding: 2
    },
    lowlight: {},
    highlight: {
      backgroundColor: 'rgba(30, 167, 253, 0.2)'
    },
    selected: {
      backgroundColor: 'rgba(2, 122, 197, 0.4)'
    }
  },
  slot: {
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: 'rgb(237, 237, 236)',
    padding: 2,
    spacing: 8
  },
  emphasis: {
    normal: 'rgb(55, 53, 47)',
    less: 'rgb(153, 153, 153)',
    more: 'rgb(6, 156, 205)'
  },
  fills: {
    gray: 'rgb(230,230,228)',
    brown: 'rgb(232,213,205)',
    purple: 'rgb(225,213,249)',
    blue: 'rgb(207,229,249)',
    green: 'rgb(206,231,225)',
    yellow: 'rgb(250,237,211)',
    orange: 'rgb(254,223,209)',
    red: 'rgb(255,207,212)',
    pink: 'rgb(249,207,230)'
  },
  text: {
    caption: {
      fontFamily: fonts.UbuntuMono,
      fontSize: 11,
      fontWeight: 300
    },
    body: {
      fontFamily: fonts.UbuntuMono,
      fontSize: 14,
      fontWeight: 300
    },
    subheading: {
      fontFamily: fonts.UbuntuMono,
      fontSize: 14,
      fontWeight: 600
    },
    heading: {
      fontFamily: fonts.UbuntuMono,
      fontSize: 20,
      fontWeight: 600
    }
  },
  icon: {
    fontSize: 16
  },
  code: {
    body: {
      fontFamily: fonts.RobotoMono,
      fontSize: 12
    }
  }
};
/**
 * This file defines a CSS-in-JS custom theme object to define visual properties (fonts,
 * colors, spacing, etc.). It extends the built-in options provided by Material UI with
 * general-purpose variables as well as domain-specific (semantically meaningful) variables.
 */

var general = {
  color: {
    white: '#FFFFFF',
    black: '#000000',
    gray: {
      l3: '#F8F9FA',
      l2: '#F1F3F5',
      l1: '#E9ECEE',
      base: '#DEE2E6',
      d1: '#B8C4CF',
      d2: '#8895A7',
      d3: '#5F6B7A'
    },
    blue: {
      l2: '#EFF8FF',
      l1: '#AAD4F6',
      base: '#3183C8',
      d1: '#2368A2',
      d2: '#194971'
    },
    teal: {
      l2: '#E7FFFE',
      l1: '#A8EEEC',
      base: '#3CAEA3',
      d1: '#2A9187',
      d2: '#1B655E'
    },
    green: {
      l2: '#E3FCEC',
      l1: '#A8EEC1',
      base: '#38C172',
      d1: '#249D57',
      d2: '#187741'
    },
    yellow: {
      l2: '#FFFCF4',
      l1: '#FDF3D7',
      base: '#F4CA64',
      d1: '#CAA53D',
      d2: '#8C6D1F'
    },
    red: {
      l2: '#FCE8E8',
      l1: '#F4AAAA',
      base: '#DC3030',
      d1: '#B82020',
      d2: '#881B1B'
    }
  },
  scale: function scale(value) {
    return value;
  }
}; // =================================================================================================

var specific = {
  vars: Object.assign({}, LightTheme)
}; // =================================================================================================

var builtin = {
  typography: {
    h1: {
      fontWeight: 300
    },
    h2: {
      fontWeight: 400
    },
    h3: {
      fontWeight: 400
    },
    h4: {
      fontWeight: 500
    },
    h5: {
      fontWeight: 500
    },
    h6: {
      fontWeight: 500
    }
  },
  palette: {
    primary: {
      main: general.color.blue.base
    },
    secondary: {
      main: general.color.teal.base
    },
    error: {
      main: general.color.red.base
    }
  },
  shape: {
    borderRadius: 2
  },
  spacing: 4,
  overrides: {
    MuiIconButton: {
      root: {
        height: 24,
        width: 24,
        color: 'inherit'
      }
    },
    MuiSvgIcon: {
      root: {
        fontSize: 18
      }
    }
  }
};
var defaultTheme = createMuiTheme(Object.assign(Object.assign(Object.assign({}, builtin), general), specific));

var Frame =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Frame, _PureComponent);

  function Frame() {
    _classCallCheck(this, Frame);

    return _possibleConstructorReturn(this, _getPrototypeOf(Frame).apply(this, arguments));
  }

  _createClass(Frame, [{
    key: "render",
    value: function render() {
      var _clsx;

      var _this$props = this.props,
          classes = _this$props.classes,
          children = _this$props.children,
          component = _this$props.component,
          light = _this$props.light,
          style = _this$props.style,
          mouseHandlers = _this$props.mouseHandlers;
      var Component = component || 'div';
      return createElement(Component, Object.assign({
        className: clsx((_clsx = {}, _defineProperty(_clsx, classes.divComponent, Component === 'div'), _defineProperty(_clsx, classes.spanComponent, Component === 'span'), _defineProperty(_clsx, classes.framed, style === 'framed'), _defineProperty(_clsx, classes.framedLowlight, style === 'framed' && light === 'lowlight'), _defineProperty(_clsx, classes.framedHighlight, style === 'framed' && light === 'highlight'), _defineProperty(_clsx, classes.framedSelected, style === 'framed' && light === 'selected'), _defineProperty(_clsx, classes.unframed, style === 'unframed'), _defineProperty(_clsx, classes.unframedLowlight, style === 'unframed' && light === 'lowlight'), _defineProperty(_clsx, classes.unframedHighlight, style === 'unframed' && light === 'highlight'), _defineProperty(_clsx, classes.unframedSelected, style === 'unframed' && light === 'selected'), _clsx))
      }, mouseHandlers), children);
    }
  }]);

  return Frame;
}(PureComponent);

Frame.defaultProps = {
  component: 'div',
  light: 'normal',
  mouseHandlers: {},
  style: 'framed'
};

var styles = function styles(theme) {
  return createStyles({
    divComponent: {
      // Allow placement in flow.
      display: 'inline-block',
      // Vertically centered in flow.
      verticalAlign: 'middle',
      // If parent too small, allow v/h scroll bars.
      overflow: 'auto',
      // As wide as possible within the parent, but no wider than the content actually needs. // By default, divs take up whole width of parent, even for content that is smaller.
      width: 'fit-content',
      // Font size must be 0 so text (e.g. in a span) has precise minimal height.
      // fontSize: 0,
      // Line height must be 1 so text (e.g. in a span) has precise minimal spacing.
      lineHeight: 1
    },
    spanComponent: {
      // Default setting properly aligns. Using 'middle' causes offset.
      verticalAlign: 'initial',
      overflow: 'auto',
      lineHeight: 1
    },
    framed: Object.assign({}, theme.vars.framed.normal),
    framedHighlight: Object.assign({}, theme.vars.framed.highlight),
    framedLowlight: Object.assign({}, theme.vars.framed.lowlight),
    framedSelected: Object.assign({}, theme.vars.framed.selected),
    unframed: Object.assign({}, theme.vars.unframed.normal),
    unframedHighlight: Object.assign({}, theme.vars.unframed.highlight),
    unframedLowlight: Object.assign({}, theme.vars.unframed.lowlight),
    unframedSelected: Object.assign({}, theme.vars.unframed.selected)
  });
};

var Frame$1 = withStyles(styles, {
  defaultTheme: defaultTheme
})(Frame);

var TextPrimitive =
/*#__PURE__*/
function (_PureComponent2) {
  _inherits(TextPrimitive, _PureComponent2);

  function TextPrimitive(props) {
    var _this;

    _classCallCheck(this, TextPrimitive);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextPrimitive).call(this, props));
    _this.state = {};
    return _this;
  }

  _createClass(TextPrimitive, [{
    key: "getHandle",
    value: function getHandle() {
      return {};
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {}
    /**
     * Renders the text as a 1 element sequence to ensure consistent formatting
     */

  }, {
    key: "render",
    value: function render() {
      var _clsx2;

      var _this$props2 = this.props,
          classes = _this$props2.classes,
          text = _this$props2.text,
          variant = _this$props2.variant,
          emphasis = _this$props2.emphasis,
          interactions = _this$props2.interactions,
          light = _this$props2.light;
      var mouseHandlers = interactions.mouseHandlers;
      var split = text.split('\n');
      return createElement(Frame$1, {
        component: 'span',
        style: 'unframed',
        light: light,
        mouseHandlers: mouseHandlers
      }, createElement("span", {
        className: clsx((_clsx2 = {}, _defineProperty(_clsx2, classes.container, true), _defineProperty(_clsx2, classes.emphasisNormal, emphasis === 'normal'), _defineProperty(_clsx2, classes.emphasisLess, emphasis === 'less'), _defineProperty(_clsx2, classes.emphasisMore, emphasis === 'more'), _defineProperty(_clsx2, classes.variantBody, variant === 'body'), _defineProperty(_clsx2, classes.variantCaption, variant === 'caption'), _defineProperty(_clsx2, classes.variantSubheading, variant === 'subheading'), _defineProperty(_clsx2, classes.variantHeading, variant === 'heading'), _clsx2))
      }, split.map(function (text, i) {
        return createElement("span", {
          key: i
        }, text, i < split.length - 1 ? createElement("br", null) : null);
      })));
    }
  }]);

  return TextPrimitive;
}(PureComponent);

TextPrimitive.defaultProps = {
  variant: 'body',
  emphasis: 'normal'
};

var styles$1 = function styles$1(theme) {
  return createStyles({
    container: {
      textAlign: 'left',
      overflow: 'hidden',
      width: 'fit-content'
    },
    emphasisNormal: {
      color: theme.vars.emphasis.normal
    },
    emphasisLess: {
      color: theme.vars.emphasis.less
    },
    emphasisMore: {
      color: theme.vars.emphasis.more
    },
    variantBody: Object.assign({}, theme.vars.text.body),
    variantCaption: Object.assign({}, theme.vars.text.caption),
    variantSubheading: Object.assign({}, theme.vars.text.subheading),
    variantHeading: Object.assign({}, theme.vars.text.heading)
  });
};

var TextPrimitive$1 = withStyles(styles$1, {
  defaultTheme: defaultTheme
})(TextPrimitive);

var TokenPrimitive =
/*#__PURE__*/
function (_PureComponent3) {
  _inherits(TokenPrimitive, _PureComponent3);

  function TokenPrimitive(props) {
    var _this2;

    _classCallCheck(this, TokenPrimitive);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(TokenPrimitive).call(this, props));
    _this2.state = {};
    return _this2;
  }

  _createClass(TokenPrimitive, [{
    key: "getHandle",
    value: function getHandle() {
      return {};
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {}
    /**
     * Renders the text as a 1 element sequence to ensure consistent formatting
     */

  }, {
    key: "render",
    value: function render() {
      var _clsx3;

      var _this$props3 = this.props,
          classes = _this$props3.classes,
          text = _this$props3.text,
          color = _this$props3.color,
          interactions = _this$props3.interactions,
          light = _this$props3.light;
      var mouseHandlers = interactions.mouseHandlers;
      var split = text.split('\n');
      return createElement(Frame$1, {
        component: 'div',
        style: 'unframed',
        light: light,
        mouseHandlers: mouseHandlers
      }, createElement("div", {
        className: clsx((_clsx3 = {}, _defineProperty(_clsx3, classes.token, true), _defineProperty(_clsx3, classes.gray, color === 'gray'), _defineProperty(_clsx3, classes.brown, color === 'brown'), _defineProperty(_clsx3, classes.purple, color === 'purple'), _defineProperty(_clsx3, classes.blue, color === 'blue'), _defineProperty(_clsx3, classes.green, color === 'green'), _defineProperty(_clsx3, classes.yellow, color === 'yellow'), _defineProperty(_clsx3, classes.orange, color === 'orange'), _defineProperty(_clsx3, classes.red, color === 'red'), _defineProperty(_clsx3, classes.pink, color === 'pink'), _clsx3))
      }, split.map(function (text, i) {
        return createElement("span", {
          key: i
        }, text, i < split.length - 1 ? createElement("br", null) : null);
      })));
    }
  }]);

  return TokenPrimitive;
}(PureComponent);

TokenPrimitive.defaultProps = {
  color: 'gray'
};

var styles$2 = function styles$2(theme) {
  return createStyles({
    token: Object.assign({
      textAlign: 'left',
      wordWrap: 'break-word',
      // overflow: 'hidden',
      // width: 'fit-content',
      padding: "".concat(theme.scale(2), "px ").concat(theme.scale(4), "px"),
      borderRadius: theme.scale(2),
      color: theme.vars.emphasis.normal
    }, theme.vars.text.body),
    gray: {
      backgroundColor: theme.vars.fills.gray
    },
    brown: {
      backgroundColor: theme.vars.fills.brown
    },
    purple: {
      backgroundColor: theme.vars.fills.purple
    },
    blue: {
      backgroundColor: theme.vars.fills.blue
    },
    green: {
      backgroundColor: theme.vars.fills.green
    },
    yellow: {
      backgroundColor: theme.vars.fills.yellow
    },
    orange: {
      backgroundColor: theme.vars.fills.orange
    },
    red: {
      backgroundColor: theme.vars.fills.red
    },
    pink: {
      backgroundColor: theme.vars.fills.pink
    }
  });
};

var TokenPrimitive$1 = withStyles(styles$2, {
  defaultTheme: defaultTheme
})(TokenPrimitive);

var IconPrimitive =
/*#__PURE__*/
function (_PureComponent4) {
  _inherits(IconPrimitive, _PureComponent4);

  function IconPrimitive(props) {
    var _this3;

    _classCallCheck(this, IconPrimitive);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(IconPrimitive).call(this, props));
    _this3.state = {};
    return _this3;
  }

  _createClass(IconPrimitive, [{
    key: "getHandle",
    value: function getHandle() {
      return {};
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {}
    /**
     * Renders the text as a 1 element sequence to ensure consistent formatting
     */

  }, {
    key: "render",
    value: function render() {
      var _clsx4;

      var _this$props4 = this.props,
          classes = _this$props4.classes,
          name = _this$props4.name,
          emphasis = _this$props4.emphasis,
          interactions = _this$props4.interactions,
          light = _this$props4.light;
      var mouseHandlers = interactions.mouseHandlers;
      return createElement(Frame$1, {
        component: 'span',
        style: 'unframed',
        light: light,
        mouseHandlers: mouseHandlers
      }, createElement("i", {
        className: clsx((_clsx4 = {}, _defineProperty(_clsx4, classes.icon, true), _defineProperty(_clsx4, classes.emphasisNormal, emphasis === 'normal'), _defineProperty(_clsx4, classes.emphasisLess, emphasis === 'less'), _defineProperty(_clsx4, classes.emphasisMore, emphasis === 'more'), _clsx4))
      }, // "add_circle" is an anomaly which requires "_outline" as a suffix
      "".concat(name).concat(name === 'add_circle' ? '_outline' : '')));
    }
  }]);

  return IconPrimitive;
}(PureComponent);

var styles$3 = function styles$3(theme) {
  return createStyles({
    icon: Object.assign(Object.assign({}, theme.vars.icon), {
      verticalAlign: 'bottom',
      fontFamily: 'Material Icons Outlined',
      'font-weight': 'normal',
      'font-style': 'normal',
      // 'line-height': 1,
      'letter-spacing': 'normal',
      'text-transform': 'none',
      display: 'inline-block',
      'white-space': 'nowrap',
      'word-wrap': 'normal',
      direction: 'ltr',
      '-moz-font-feature-settings': 'liga',
      '-moz-osx-font-smoothing': 'grayscale'
    }),
    emphasisNormal: {
      color: theme.vars.emphasis.normal
    },
    emphasisLess: {
      color: theme.vars.emphasis.less
    },
    emphasisMore: {
      color: theme.vars.emphasis.more
    }
  });
};

var IconPrimitive$1 = withStyles(styles$3, {
  defaultTheme: defaultTheme
})(IconPrimitive);

var ImagePrimitive =
/*#__PURE__*/
function (_PureComponent5) {
  _inherits(ImagePrimitive, _PureComponent5);

  function ImagePrimitive(props) {
    var _this4;

    _classCallCheck(this, ImagePrimitive);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(ImagePrimitive).call(this, props));
    _this4.state = {};
    return _this4;
  }

  _createClass(ImagePrimitive, [{
    key: "getHandle",
    value: function getHandle() {
      return {};
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {}
    /**
     * Renders the text as a 1 element sequence to ensure consistent formatting
     */

  }, {
    key: "render",
    value: function render() {
      var _clsx5;

      var _this$props5 = this.props,
          classes = _this$props5.classes,
          image = _this$props5.image,
          interactions = _this$props5.interactions,
          light = _this$props5.light;
      var mouseHandlers = interactions.mouseHandlers;
      return createElement("img", Object.assign({
        className: clsx((_clsx5 = {}, _defineProperty(_clsx5, classes.image, true), _defineProperty(_clsx5, classes.imageHighlight, light === 'highlight'), _clsx5)),
        src: /^(~|\/|http)/.test(image) ? image : "data:image/png;base64,".concat(image),
        style: {
          maxWidth: 400
        },
        onError: function onError(e) {
          e.target.onerror = null;
          e.target.src = './img-not-found.png';
        }
      }, mouseHandlers));
    }
  }]);

  return ImagePrimitive;
}(PureComponent);

var styles$4 = function styles$4(theme) {
  return createStyles({
    image: {
      marginLeft: theme.scale(8),
      marginRight: theme.scale(8),
      borderColor: 'transparent'
    },
    imageHighlight: {
      borderColor: theme.palette.primary.light
    }
  });
};

var ImagePrimitive$1 = withStyles(styles$4, {
  defaultTheme: defaultTheme
})(ImagePrimitive);

var SwitchLayout =
/*#__PURE__*/
function (_PureComponent6) {
  _inherits(SwitchLayout, _PureComponent6);

  function SwitchLayout(props) {
    var _this5;

    _classCallCheck(this, SwitchLayout);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(SwitchLayout).call(this, props));

    _this5._childViewerCallback = function (viewer) {
      return _this5._childViewer = viewer;
    };

    _this5.state = {
      selectedModeIdx: 0
    };

    _this5._childViewerCallback.bind(_assertThisInitialized(_this5));

    return _this5;
  }

  _createClass(SwitchLayout, [{
    key: "_getChildViewerCallback",
    value: function _getChildViewerCallback() {
      return this._childViewerCallback;
    }
  }, {
    key: "getHandle",
    value: function getHandle() {
      var _this6 = this;

      var selectedModeIdx = this.state.selectedModeIdx;
      return {
        mode: this._childViewer.viewerId,
        selectedModeIdx: selectedModeIdx,
        doSelectMode: function doSelectMode(idx) {
          _this6.setState({
            selectedModeIdx: idx
          });
        },
        doIncrementMode: function doIncrementMode() {
          var delta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
          var modes = _this6.props.modes;

          _this6.setState(function (state) {
            var modeIdx = state.selectedModeIdx + delta; // Ensure wrapping to valid array index.

            modeIdx = (modeIdx % modes.length + modes.length) % modes.length;
            return {
              selectedModeIdx: modeIdx
            };
          });
        }
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props$interacti = this.props.interactions,
          viewerId = _this$props$interacti.viewerId,
          emit = _this$props$interacti.emit;
      var selectedModeIdx = this.state.selectedModeIdx;

      if (selectedModeIdx !== prevState.selectedModeIdx) {
        emit('Switch.DidSelectMode', {
          viewerId: viewerId,
          selectedModeIdx: selectedModeIdx
        });
      }
    }
    /**
     * Renders a sequence of `Viewer` elements, optionally numbered with indices. The sequence can
     * have start/end motifs, which are large characters that can be used to indicate a type of
     * sequence (e.g. "{" for sets).
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          classes = _this$props6.classes,
          passdown = _this$props6.passdown,
          interactions = _this$props6.interactions,
          light = _this$props6.light;
      var mouseHandlers = interactions.mouseHandlers;
      var _this$props7 = this.props,
          modes = _this$props7.modes,
          showLabels = _this$props7.showLabels;
      var selectedModeIdx = this.state.selectedModeIdx;
      var fragmentId = modes[selectedModeIdx];
      return createElement(Frame$1, {
        component: 'div',
        style: 'framed',
        light: light,
        mouseHandlers: mouseHandlers
      }, createElement("div", {
        className: classes.slot
      }, createElement(Viewer, Object.assign({
        ref: this._getChildViewerCallback(),
        key: fragmentId
      }, passdown, {
        fragmentId: fragmentId
      }))), createElement("div", {
        className: classes.border
      }, createElement("div", {
        className: classes.indicator
      }, modes.map(function (_, idx) {
        return idx === selectedModeIdx ? "\u25CF" : "\u25CB";
      })), showLabels ? createElement("div", {
        className: classes.label
      }, selectedModeIdx) : null));
    }
  }]);

  return SwitchLayout;
}(PureComponent);

SwitchLayout.defaultProps = {
  showLabels: true
};

var styles$5 = function styles$5(theme) {
  return createStyles({
    slot: {
      paddingLeft: theme.vars.slot.padding,
      paddingRight: theme.vars.slot.padding,
      paddingBottom: theme.vars.slot.padding,
      verticalAlign: 'bottom'
    },
    border: {
      borderTopColor: theme.vars.slot.borderColor,
      borderTopStyle: theme.vars.slot.borderStyle,
      borderTopWidth: theme.vars.slot.borderWidth
    },
    indicator: Object.assign(Object.assign({
      display: 'inline-block',
      float: 'left',
      paddingLeft: theme.vars.slot.padding
    }, theme.vars.text.caption), {
      color: theme.vars.emphasis.less
    }),
    label: Object.assign(Object.assign({
      display: 'inline-block',
      float: 'right',
      paddingRight: theme.vars.slot.padding,
      paddingBottom: theme.vars.slot.padding
    }, theme.vars.text.caption), {
      color: theme.vars.emphasis.less
    })
  });
};

var SwitchLayout$1 = withStyles(styles$5, {
  defaultTheme: defaultTheme
})(SwitchLayout);

var GridLayout =
/*#__PURE__*/
function (_PureComponent7) {
  _inherits(GridLayout, _PureComponent7);

  function GridLayout(props) {
    var _this7;

    _classCallCheck(this, GridLayout);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(GridLayout).call(this, props));
    _this7._childViewers = [];
    _this7._childViewerCallbacks = {};
    _this7.state = {
      selectedCellIdx: 0
    };

    _this7._getChildViewerCallback.bind(_assertThisInitialized(_this7));

    return _this7;
  }

  _createClass(GridLayout, [{
    key: "_getChildViewerCallback",
    value: function _getChildViewerCallback(idx) {
      var _this8 = this;

      var key = "".concat(idx);

      if (!this._childViewerCallbacks[key]) {
        this._childViewerCallbacks[key] = function (viewer) {
          return _this8._childViewers[idx] = viewer;
        };
      }

      return this._childViewerCallbacks[key];
    }
  }, {
    key: "getHandle",
    value: function getHandle() {
      var _this9 = this;

      var selectedCellIdx = this.state.selectedCellIdx;
      return {
        cells: this._childViewers.map(function (viewer) {
          return viewer.viewerId;
        }),
        selectedCellIdx: selectedCellIdx,
        doSelectCell: function doSelectCell(cellIdx) {
          _this9.setState({
            selectedCellIdx: cellIdx
          });
        },
        doSelectNeighborCell: function doSelectNeighborCell(direction) {
          _this9.setState(function (state, props) {
            var cells = props.cells;
            var currentElem = cells[state.selectedCellIdx]; // TODO: Rewrite with clearer logic.

            var mainAxis;
            var offAxis;
            var increaseMainAxis;

            switch (direction) {
              case 'south':
                mainAxis = 'row';
                offAxis = 'col';
                increaseMainAxis = true;
                break;

              case 'east':
                mainAxis = 'col';
                offAxis = 'row';
                increaseMainAxis = true;
                break;

              case 'north':
                mainAxis = 'row';
                offAxis = 'col';
                increaseMainAxis = false;
                break;

              default:
              case 'west':
                mainAxis = 'col';
                offAxis = 'row';
                increaseMainAxis = false;
                break;
            }

            var mainSize = mainAxis === 'row' ? 'height' : 'width';
            var mainEdge = increaseMainAxis ? currentElem[mainAxis] + currentElem[mainSize] : currentElem[mainAxis];
            var cellPenalties = cells.map(function (cell, i) {
              var penalty = {
                idx: i,
                off: 0,
                main: 0,
                valid: true
              };

              if (i === state.selectedCellIdx || increaseMainAxis && cell[mainAxis] < mainEdge || !increaseMainAxis && cell[mainAxis] >= mainEdge) {
                penalty.valid = false;
              }

              penalty.off = Math.abs(cell[offAxis] - currentElem[offAxis]);
              penalty.main = Math.abs(cell[mainAxis] - mainEdge);
              return penalty;
            }).filter(function (c) {
              return c.valid;
            }).sort(function (c1, c2) {
              return c1.off === c2.off ? c1.main - c2.main : c1.off - c2.off;
            });

            if (cellPenalties.length > 0) {
              return {
                selectedCellIdx: cellPenalties[0].idx
              };
            } else {
              return {
                selectedCellIdx: selectedCellIdx
              };
            }
          });
        }
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props$interacti2 = this.props.interactions,
          viewerId = _this$props$interacti2.viewerId,
          emit = _this$props$interacti2.emit;
      var selectedCellIdx = this.state.selectedCellIdx;

      if (selectedCellIdx !== prevState.selectedCellIdx) {
        emit('Grid.DidSelectCell', {
          viewerId: viewerId,
          selectedCellIdx: selectedCellIdx,
          prevSelectedCellIdx: prevState.selectedCellIdx
        });
      }
    }
    /**
     * Renders a sequence of `Viewer` elements, optionally numbered with indices. The sequence can
     * have start/end motifs, which are large characters that can be used to indicate a type of
     * sequence (e.g. "{" for sets).
     */

  }, {
    key: "render",
    value: function render() {
      var _clsx6,
          _this10 = this;

      var _this$props8 = this.props,
          classes = _this$props8.classes,
          passdown = _this$props8.passdown,
          interactions = _this$props8.interactions,
          light = _this$props8.light;
      var mouseHandlers = interactions.mouseHandlers;
      var _this$props9 = this.props,
          cells = _this$props9.cells,
          rowHeight = _this$props9.rowHeight,
          colWidth = _this$props9.colWidth,
          showLabels = _this$props9.showLabels;
      var maxRow = cells.reduce(function (max, _ref) {
        var row = _ref.row,
            height = _ref.height;
        return Math.max(max, row + height);
      }, -1);
      var maxCol = cells.reduce(function (max, _ref2) {
        var col = _ref2.col,
            width = _ref2.width;
        return Math.max(max, col + width);
      }, -1);
      return createElement(Frame$1, {
        component: 'div',
        style: 'framed',
        light: light,
        mouseHandlers: mouseHandlers
      }, createElement("div", {
        className: clsx((_clsx6 = {}, _defineProperty(_clsx6, classes.grid, true), _defineProperty(_clsx6, classes.equalColumns, colWidth === 'equal'), _defineProperty(_clsx6, classes.equalRows, rowHeight === 'equal'), _clsx6))
      }, cells.map(function (_ref3, idx) {
        var _clsx7;

        var fragmentId = _ref3.fragmentId,
            col = _ref3.col,
            row = _ref3.row,
            width = _ref3.width,
            height = _ref3.height;
        return createElement("div", {
          key: "".concat(idx, "-").concat(fragmentId),
          className: clsx((_clsx7 = {}, _defineProperty(_clsx7, classes.cell, true), _defineProperty(_clsx7, classes.edgeTop, row === 0), _defineProperty(_clsx7, classes.edgeBottom, row + height === maxRow), _defineProperty(_clsx7, classes.edgeLeft, col === 0), _defineProperty(_clsx7, classes.edgeRight, col + width === maxCol), _clsx7)),
          style: {
            gridColumn: "".concat(col + 1, " / ").concat(col + 1 + width),
            gridRow: "".concat(row + 1, " / ").concat(row + 1 + height)
          }
        }, createElement(Viewer, Object.assign({
          ref: _this10._getChildViewerCallback(idx)
        }, passdown, {
          fragmentId: fragmentId
        })));
      })));
    }
  }]);

  return GridLayout;
}(PureComponent);

var styles$6 = function styles$6(theme) {
  return createStyles({
    grid: {
      display: 'grid',
      justifyContent: 'start',
      gridAutoColumns: 'max-content',
      gridAutoRows: 'max-content'
    },
    equalRows: {
      gridAutoRows: '1fr'
    },
    equalColumns: {
      gridAutoColumns: '1fr'
    },
    cell: {
      flexGrow: 1,
      textAlign: 'left',
      padding: theme.vars.slot.padding,
      borderLeftStyle: theme.vars.slot.borderStyle,
      borderLeftColor: theme.vars.slot.borderColor,
      borderLeftWidth: theme.vars.slot.borderWidth,
      borderTopStyle: theme.vars.slot.borderStyle,
      borderTopColor: theme.vars.slot.borderColor,
      borderTopWidth: theme.vars.slot.borderWidth
    },
    edgeLeft: {
      borderLeft: 'none'
    },
    edgeRight: {},
    edgeTop: {
      borderTop: 'none'
    },
    edgeBottom: {}
  });
};

var GridLayout$1 = withStyles(styles$6, {
  defaultTheme: defaultTheme
})(GridLayout);

var SequenceLayout =
/*#__PURE__*/
function (_PureComponent8) {
  _inherits(SequenceLayout, _PureComponent8);

  function SequenceLayout(props) {
    var _this11;

    _classCallCheck(this, SequenceLayout);

    _this11 = _possibleConstructorReturn(this, _getPrototypeOf(SequenceLayout).call(this, props));
    _this11._childViewers = [];
    _this11._childViewerCallbacks = {};
    _this11.state = {
      selectedElementIdx: 0
    };

    _this11._getChildViewerCallback.bind(_assertThisInitialized(_this11));

    return _this11;
  }

  _createClass(SequenceLayout, [{
    key: "_getChildViewerCallback",
    value: function _getChildViewerCallback(idx) {
      var _this12 = this;

      var key = "".concat(idx);

      if (!this._childViewerCallbacks[key]) {
        this._childViewerCallbacks[key] = function (viewer) {
          return _this12._childViewers[idx] = viewer;
        };
      }

      return this._childViewerCallbacks[key];
    }
  }, {
    key: "getHandle",
    value: function getHandle() {
      var _this13 = this;

      var selectedElementIdx = this.state.selectedElementIdx;
      return {
        elements: this._childViewers.map(function (viewer) {
          return viewer.viewerId;
        }),
        selectedElementIdx: selectedElementIdx,
        doSelectElement: function doSelectElement(idx) {
          _this13.setState({
            selectedElementIdx: idx
          });
        },
        doIncrementElement: function doIncrementElement() {
          var delta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
          var elements = _this13.props.elements;

          _this13.setState(function (state) {
            var elementIdx = state.selectedElementIdx + delta; // Ensure wrapping to valid array index.

            elementIdx = (elementIdx % elements.length + elements.length) % elements.length;
            return {
              selectedElementIdx: elementIdx
            };
          });
        }
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props$interacti3 = this.props.interactions,
          viewerId = _this$props$interacti3.viewerId,
          emit = _this$props$interacti3.emit;
      var selectedElementIdx = this.state.selectedElementIdx;

      if (selectedElementIdx !== prevState.selectedElementIdx) {
        emit('Sequence.DidSelectElement', {
          viewerId: viewerId,
          selectedElementIdx: selectedElementIdx,
          prevSelectedElementIdx: prevState.selectedElementIdx
        });
      }
    }
    /**
     * Renders a sequence of `Viewer` elements, optionally numbered with indices. The sequence can
     * have start/end motifs, which are large characters that can be used to indicate a type of
     * sequence (e.g. "{" for sets).
     */

  }, {
    key: "render",
    value: function render() {
      var _this14 = this;

      var _this$props10 = this.props,
          classes = _this$props10.classes,
          passdown = _this$props10.passdown,
          interactions = _this$props10.interactions,
          light = _this$props10.light;
      var mouseHandlers = interactions.mouseHandlers;
      var _this$props11 = this.props,
          elements = _this$props11.elements,
          orientation = _this$props11.orientation,
          startMotif = _this$props11.startMotif,
          endMotif = _this$props11.endMotif,
          showLabels = _this$props11.showLabels;
      return createElement(Frame$1, {
        component: 'div',
        style: 'framed',
        light: light,
        mouseHandlers: mouseHandlers
      }, createElement("div", {
        className: classes.container
      }, createElement("div", {
        className: clsx(classes.motif, classes.motifStart),
        key: 'startMotif'
      }, startMotif), createElement("div", {
        className: classes.elements
      }, elements.map(function (fragmentId, idx) {
        var _clsx8, _clsx9;

        var ViewerElement = createElement(Viewer, Object.assign({
          ref: _this14._getChildViewerCallback(idx),
          key: "".concat(idx, "-").concat(fragmentId)
        }, passdown, {
          fragmentId: fragmentId
        }));
        var gridPos = "".concat(idx + 1, " / ").concat(idx + 2);
        return orientation === 'horizontal' ? createElement(Fragment, {
          key: idx
        }, createElement("div", {
          className: clsx((_clsx8 = {}, _defineProperty(_clsx8, classes.borderHorizontal, true), _defineProperty(_clsx8, classes.labelHorizontal, showLabels), _clsx8)),
          style: {
            gridColumn: gridPos,
            gridRow: '2 / 3'
          }
        }, showLabels ? idx : null), createElement("div", {
          className: classes.slotHorizontal,
          style: {
            gridColumn: gridPos,
            gridRow: '1 / 2'
          }
        }, ViewerElement)) : createElement(Fragment, {
          key: idx
        }, createElement("div", {
          className: clsx((_clsx9 = {}, _defineProperty(_clsx9, classes.borderVertical, true), _defineProperty(_clsx9, classes.labelVertical, showLabels), _clsx9)),
          style: {
            gridColumn: '1 / 2',
            gridRow: gridPos
          }
        }, showLabels ? idx : null), createElement("div", {
          className: classes.slotVertical,
          style: {
            gridColumn: '2 / 3',
            gridRow: gridPos
          }
        }, ViewerElement));
      })), createElement("div", {
        className: clsx(classes.motif, classes.motifEnd),
        key: 'endMotif'
      }, endMotif)));
    }
  }]);

  return SequenceLayout;
}(PureComponent);

SequenceLayout.defaultProps = {
  orientation: 'horizontal',
  showLabels: false
};

var styles$7 = function styles$7(theme) {
  return createStyles({
    container: {
      display: 'flex',
      flexDirection: 'row',
      whiteSpace: 'nowrap'
    },
    motif: Object.assign(Object.assign({
      display: 'block'
    }, theme.vars.text.subheading), {
      color: theme.vars.emphasis.less
    }),
    motifStart: {
      textAlign: 'right'
    },
    motifEnd: {
      textAlign: 'left'
    },
    elements: {
      display: 'grid'
    },
    slotHorizontal: {
      padding: theme.vars.slot.padding,
      alignSelf: 'end'
    },
    borderHorizontal: {
      borderTopColor: theme.vars.slot.borderColor,
      borderTopStyle: theme.vars.slot.borderStyle,
      borderTopWidth: theme.vars.slot.borderWidth
    },
    labelHorizontal: Object.assign(Object.assign({
      paddingLeft: theme.vars.slot.padding,
      paddingRight: theme.vars.slot.padding,
      textAlign: 'left'
    }, theme.vars.text.caption), {
      color: theme.vars.emphasis.less
    }),
    slotVertical: {
      padding: theme.vars.slot.padding,
      alignSelf: 'start'
    },
    borderVertical: {
      borderRightColor: theme.vars.slot.borderColor,
      borderRightStyle: theme.vars.slot.borderStyle,
      borderRightWidth: theme.vars.slot.borderWidth
    },
    labelVertical: Object.assign(Object.assign({
      paddingRight: theme.vars.slot.padding,
      textAlign: 'right'
    }, theme.vars.text.caption), {
      color: theme.vars.emphasis.less
    })
  });
};

var SequenceLayout$1 = withStyles(styles$7, {
  defaultTheme: defaultTheme
})(SequenceLayout);

var KeyValueLayout =
/*#__PURE__*/
function (_PureComponent9) {
  _inherits(KeyValueLayout, _PureComponent9);

  function KeyValueLayout(props) {
    var _this15;

    _classCallCheck(this, KeyValueLayout);

    _this15 = _possibleConstructorReturn(this, _getPrototypeOf(KeyValueLayout).call(this, props));
    _this15._childViewers = [];
    _this15._childViewerCallbacks = {};
    _this15.state = {
      selectedEntryIdx: 0,
      selectedEntryType: 'key'
    };

    _this15._getChildViewerCallback.bind(_assertThisInitialized(_this15));

    return _this15;
  }

  _createClass(KeyValueLayout, [{
    key: "_getChildViewerCallback",
    value: function _getChildViewerCallback(idx, type) {
      var _this16 = this;

      var key = "".concat(idx, "-").concat(type);

      if (!this._childViewerCallbacks[key]) {
        this._childViewerCallbacks[key] = function (viewer) {
          if (!_this16._childViewers[idx]) _this16._childViewers[idx] = {};
          _this16._childViewers[idx][type] = viewer;
        };
      }

      return this._childViewerCallbacks[key];
    }
  }, {
    key: "getHandle",
    value: function getHandle() {
      var _this17 = this;

      var _this$state = this.state,
          selectedEntryIdx = _this$state.selectedEntryIdx,
          selectedEntryType = _this$state.selectedEntryType;
      return {
        // If there are no children, we should not return an empty list, since this will raise
        // an exception if a user, in the interaction manager, tries to access 
        // `entries[selectedEntryIdx][selectedEntryType]`. Instead, we put `{key, value}` object
        // as the only entry so that the access does not throw an error but will return invalid
        // Viewer IDs.
        entries: this._childViewers.length > 0 ? this._childViewers.map(function (_ref4) {
          var key = _ref4.key,
              value = _ref4.value;
          return {
            key: key.viewerId,
            value: value.viewerId
          };
        }) : [{
          key: '',
          value: ''
        }],
        selectedEntryIdx: selectedEntryIdx,
        selectedEntryType: selectedEntryType,
        doSelectEntry: function doSelectEntry(idx) {
          _this17.setState({
            selectedEntryIdx: idx
          });
        },
        doIncrementEntry: function doIncrementEntry() {
          var delta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
          var entries = _this17.props.entries;

          _this17.setState(function (state) {
            var entryIdx = state.selectedEntryIdx + delta; // Ensure wrapping to valid array index.

            entryIdx = (entryIdx % entries.length + entries.length) % entries.length;
            return {
              selectedEntryIdx: entryIdx
            };
          });
        },
        doSelectKey: function doSelectKey() {
          _this17.setState({
            selectedEntryType: 'key'
          });
        },
        doSelectValue: function doSelectValue() {
          _this17.setState({
            selectedEntryType: 'value'
          });
        }
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props$interacti4 = this.props.interactions,
          viewerId = _this$props$interacti4.viewerId,
          emit = _this$props$interacti4.emit;
      var _this$state2 = this.state,
          selectedEntryIdx = _this$state2.selectedEntryIdx,
          selectedEntryType = _this$state2.selectedEntryType;

      if (selectedEntryIdx !== prevState.selectedEntryIdx || selectedEntryType !== prevState.selectedEntryType) {
        emit('KeyValue.DidSelectEntry', {
          viewerId: viewerId,
          selectedEntryIdx: selectedEntryIdx,
          selectedEntryType: selectedEntryType,
          prevSelectedEntryIdx: prevState.selectedEntryIdx,
          prevSelectedEntryType: prevState.selectedEntryType
        });
      }
    }
    /**
     * Renders a sequence of `Viewer` elements, optionally numbered with indices. The sequence can
     * have start/end motifs, which are large characters that can be used to indicate a type of
     * sequence (e.g. "{" for sets).
     */

  }, {
    key: "render",
    value: function render() {
      var _this18 = this;

      var _this$props12 = this.props,
          classes = _this$props12.classes,
          passdown = _this$props12.passdown,
          interactions = _this$props12.interactions,
          light = _this$props12.light;
      var mouseHandlers = interactions.mouseHandlers;
      var _this$props13 = this.props,
          entries = _this$props13.entries,
          separator = _this$props13.separator,
          startMotif = _this$props13.startMotif,
          endMotif = _this$props13.endMotif,
          alignSeparators = _this$props13.alignSeparators,
          showLabels = _this$props13.showLabels;
      return createElement(Frame$1, {
        component: 'div',
        style: 'framed',
        light: light,
        mouseHandlers: mouseHandlers
      }, createElement("div", {
        className: classes.container
      }, createElement("div", {
        className: clsx(classes.motif, classes.motifStart)
      }, startMotif), createElement("div", {
        className: classes.entries
      }, entries.map(function (_ref5, idx) {
        var _clsx10;

        var key = _ref5.key,
            value = _ref5.value;
        var ViewerKey = createElement(Viewer, Object.assign({
          ref: _this18._getChildViewerCallback(idx, 'key'),
          key: "k".concat(idx)
        }, passdown, {
          fragmentId: key
        }));
        var ViewerValue = createElement(Viewer, Object.assign({
          ref: _this18._getChildViewerCallback(idx, 'value'),
          key: "v".concat(idx)
        }, passdown, {
          fragmentId: value
        }));
        var gridRow = "".concat(idx + 1, " / ").concat(idx + 2);
        return createElement(Fragment, {
          key: idx
        }, createElement("div", {
          className: clsx((_clsx10 = {}, _defineProperty(_clsx10, classes.border, true), _defineProperty(_clsx10, classes.label, showLabels), _clsx10)),
          style: {
            gridColumn: "1 / 2",
            gridRow: gridRow
          }
        }, showLabels ? idx : null), alignSeparators ? createElement(Fragment, null, createElement("div", {
          className: classes.slot,
          style: {
            gridColumn: "2 / 3",
            gridRow: gridRow
          }
        }, ViewerKey), createElement("div", {
          className: classes.separator,
          style: {
            gridColumn: "3 / 4",
            gridRow: gridRow
          }
        }, separator), createElement("div", {
          className: classes.slot,
          style: {
            gridColumn: "4 / 5",
            gridRow: gridRow
          }
        }, ViewerValue)) : createElement("div", {
          style: {
            gridColumn: "2 / 3",
            gridRow: gridRow
          }
        }, createElement("div", {
          className: classes.slot
        }, ViewerKey), createElement("div", {
          className: clsx(classes.separator, classes.spacingAround)
        }, separator), createElement("div", {
          className: classes.slot
        }, ViewerValue))); // </div>
      })), createElement("div", {
        className: clsx(classes.motif, classes.motifEnd)
      }, endMotif)));
    }
  }]);

  return KeyValueLayout;
}(PureComponent);

KeyValueLayout.defaultProps = {
  separator: ':',
  alignSeparators: false,
  showLabels: true
};

var styles$8 = function styles$8(theme) {
  return createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      whiteSpace: 'nowrap'
    },
    entries: {
      display: 'grid',
      gridRowGap: theme.vars.slot.padding,
      gridColumnGap: theme.vars.slot.spacing
    },
    border: {
      borderRightColor: theme.vars.slot.borderColor,
      borderRightStyle: theme.vars.slot.borderStyle,
      borderRightWidth: theme.vars.slot.borderWidth
    },
    label: Object.assign(Object.assign({
      paddingRight: theme.vars.slot.padding,
      textAlign: 'right'
    }, theme.vars.text.caption), {
      color: theme.vars.emphasis.less
    }),
    slot: {
      display: 'inline-block'
    },
    separator: Object.assign(Object.assign({
      display: 'inline-block'
    }, theme.vars.text.body), {
      color: theme.vars.emphasis.less
    }),
    spacingAround: {
      marginLeft: theme.vars.slot.spacing,
      marginRight: theme.vars.slot.spacing
    },
    motif: Object.assign(Object.assign({
      display: 'block'
    }, theme.vars.text.caption), {
      color: theme.vars.emphasis.less
    }),
    motifStart: {
      textAlign: 'right'
    },
    motifEnd: {
      textAlign: 'left'
    }
  });
};

var KeyValueLayout$1 = withStyles(styles$8, {
  defaultTheme: defaultTheme
})(KeyValueLayout);
/** The pixel width of the interactive border surrounding expansible/collapsible nodes. */

var kBorderWidth = 8;
var kLabelPadding = 2;
var kLabelHeight = 12;

var DagNode =
/*#__PURE__*/
function (_PureComponent10) {
  _inherits(DagNode, _PureComponent10);

  function DagNode(props) {
    var _this19;

    _classCallCheck(this, DagNode);

    _this19 = _possibleConstructorReturn(this, _getPrototypeOf(DagNode).call(this, props));
    _this19.content = undefined;
    _this19.width = 0;
    _this19.height = 0;
    _this19.setContentRef = _this19.setContentRef.bind(_assertThisInitialized(_this19));
    return _this19;
  }

  _createClass(DagNode, [{
    key: "updateSize",
    value: function updateSize() {
      var _this$props14 = this.props,
          isInteractive = _this$props14.isInteractive,
          onResize = _this$props14.onResize;
      var DOMNode = ReactDOM.findDOMNode(this.content);

      if (DOMNode) {
        var width = DOMNode.offsetWidth;
        var height = DOMNode.offsetHeight;
        isInteractive ? onResize(width + kBorderWidth * 2, height + kBorderWidth * 2) : onResize(width, height);
        this.width = width;
        this.height = height;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateSize();
    }
  }, {
    key: "setContentRef",
    value: function setContentRef(ref) {
      this.content = ref;
      this.updateSize();
    }
  }, {
    key: "render",
    value: function render() {
      var _clsx12;

      var _this$props15 = this.props,
          classes = _this$props15.classes,
          x = _this$props15.x,
          y = _this$props15.y,
          width = _this$props15.width,
          height = _this$props15.height,
          label = _this$props15.label,
          children = _this$props15.children,
          isVisible = _this$props15.isVisible,
          isInteractive = _this$props15.isInteractive,
          light = _this$props15.light,
          isExpanded = _this$props15.isExpanded,
          mouseHandlers = _this$props15.mouseHandlers; // If the node is expanded, render an interactive rectangle

      if (isExpanded) {
        var _clsx11;

        return createElement("g", null, createElement("rect", Object.assign({
          x: x - width / 2,
          y: y - height / 2,
          width: width,
          height: height,
          rx: 8,
          ry: 8,
          className: clsx((_clsx11 = {}, _defineProperty(_clsx11, classes.expandedInvisible, !isVisible), _defineProperty(_clsx11, classes.expandedVisible, isVisible), _defineProperty(_clsx11, classes.expandedHighlighted, isVisible && light === 'highlight'), _clsx11))
        }, mouseHandlers)), label && (light === "highlight" || light === "selected") ? createElement("foreignObject", {
          x: x - width / 2,
          y: y - height / 2 - kLabelPadding - kLabelHeight,
          width: width,
          height: kLabelHeight
        }, createElement("div", {
          className: classes.label
        }, label)) : null);
      } // If not expanded, render the node, surrounded by an interactive border if `isInteractive`


      var foreignObjectPos = isInteractive ? {
        x: x - width / 2 + kBorderWidth,
        y: y - height / 2 + kBorderWidth,
        width: width - kBorderWidth * 2,
        height: height - kBorderWidth * 2
      } : {
        x: x - width / 2,
        y: y - height / 2,
        width: width,
        height: height
      };
      return createElement("g", null, isInteractive ? createElement("rect", Object.assign({
        x: x - width / 2,
        y: y - height / 2,
        width: width,
        height: height,
        rx: 8,
        ry: 8,
        className: clsx((_clsx12 = {}, _defineProperty(_clsx12, classes.expandedInvisible, !isVisible), _defineProperty(_clsx12, classes.expandedVisible, isVisible), _defineProperty(_clsx12, classes.expandedHighlighted, isVisible && light === 'highlight'), _clsx12))
      }, mouseHandlers)) : null, createElement("foreignObject", Object.assign({}, foreignObjectPos), createElement("div", {
        ref: this.setContentRef,
        style: {
          display: 'inline-block'
        }
      }, children)));
    }
  }]);

  return DagNode;
}(PureComponent);

DagNode.defaultProps = {
  isInteractive: true,
  isVisible: true
};

var styles$9 = function styles$9(theme) {
  return createStyles({
    expandedInvisible: {
      strokeWidth: 0,
      fill: 'transparent'
    },
    expandedVisible: {
      stroke: theme.vars.slot.borderColor,
      strokeWidth: theme.vars.slot.borderWidth,
      fill: 'transparent'
    },
    expandedHighlighted: {
      stroke: theme.vars.framed.highlight.borderLeftColor
    },
    label: {
      fontSize: theme.typography.caption.fontSize,
      fontFamily: theme.typography.caption.fontFamily,
      fontWeight: theme.typography.caption.fontWeight,
      color: theme.typography.caption.color,
      pointerEvents: 'none'
    }
  });
};

var DagNodeComponent = withStyles(styles$9, {
  defaultTheme: defaultTheme
})(DagNode);
var kTemporalBump = 20;

var DagEdge =
/*#__PURE__*/
function (_PureComponent11) {
  _inherits(DagEdge, _PureComponent11);

  function DagEdge() {
    var _this20;

    _classCallCheck(this, DagEdge);

    _this20 = _possibleConstructorReturn(this, _getPrototypeOf(DagEdge).apply(this, arguments));
    _this20._xlinkId = cuid();
    return _this20;
  }

  _createClass(DagEdge, [{
    key: "render",
    value: function render() {
      var _clsx14, _clsx15;

      var _this$props16 = this.props,
          classes = _this$props16.classes,
          shape = _this$props16.shape,
          light = _this$props16.light,
          temporal = _this$props16.temporal,
          label = _this$props16.label,
          mouseHandlers = _this$props16.mouseHandlers;
      var points = this.props.points;
      if (!points || points.length === 0) return null; // Bump end of line to make room for sharp arrowhead
      // if (points.length >= 2) {
      //     points = points.map(({ x, y }) => ({ x , y }));
      //     const [p, q] = points.slice(points.length - 2);
      //     const pq = { x : q.x - p.x, y: q.y - p.y };
      //     const dist = Math.pow(pq.x * pq.x + pq.y * pq.y, 0.5);
      //     if(dist > kEdgeGap) {
      //         q.x -= pq.x / dist * kEdgeGap;
      //         q.y -= pq.y / dist * kEdgeGap;
      //     }
      // }

      var path;
      var startPoint = points[0];
      var endPoint = points[points.length - 1];

      if (temporal) {
        points = [startPoint, {
          x: startPoint.x + kTemporalBump,
          y: startPoint.y + kTemporalBump
        }, {
          x: endPoint.x - kTemporalBump,
          y: endPoint.y - kTemporalBump
        }, endPoint];
        path = line().curve(curveBasis)(points.map(function (_ref6) {
          var x = _ref6.x,
              y = _ref6.y;
          return [x, y];
        }));
      } else {
        path = line()(points.map(function (_ref7) {
          var x = _ref7.x,
              y = _ref7.y;
          return [x, y];
        })); // path = 'M ' + points.map(({ x, y }) => `${x} ${y}`).join(' L ');
      }

      if (path) {
        // path = serialize(roundCorners(parse(path), kEdgeCurveRadius));
        path = serialize(parse(path));
      }

      return createElement("g", null, createElement("path", Object.assign({
        d: path || undefined,
        className: clsx(_defineProperty({}, classes.hotspot, true))
      }, mouseHandlers)), createElement("path", {
        id: this._xlinkId,
        d: path || undefined,
        pointerEvents: 'none',
        className: clsx((_clsx14 = {}, _defineProperty(_clsx14, classes.edge, true), _defineProperty(_clsx14, classes.edgeHighlight, light === 'highlight'), _defineProperty(_clsx14, classes.edgeLowlight, light === 'lowlight'), _defineProperty(_clsx14, classes.edgeSelected, light === 'selected'), _clsx14))
      }), createElement("text", {
        dy: '-1.5',
        textAnchor: 'end',
        pointerEvents: 'none',
        className: clsx((_clsx15 = {}, _defineProperty(_clsx15, classes.edgeLabel, true), _defineProperty(_clsx15, classes.edgeLabelHighlight, light === 'highlight'), _defineProperty(_clsx15, classes.edgeLabelLowlight, light === 'lowlight'), _defineProperty(_clsx15, classes.edgeLabelSelected, light === 'selected'), _clsx15))
      }, createElement("textPath", {
        xlinkHref: "#".concat(this._xlinkId),
        startOffset: '95%'
      }, label)));
    }
  }]);

  return DagEdge;
}(PureComponent);

DagEdge.defaultProps = {
  points: [],
  shape: 'line',
  light: 'normal',
  temporal: false
};

var styles$a = function styles$a(theme) {
  return createStyles({
    edge: {
      fill: 'none',
      stroke: theme.color.gray.d2,
      strokeWidth: 2.5,
      opacity: 1,
      markerEnd: 'url(#arrow-normal)'
    },
    hotspot: {
      fill: 'none',
      stroke: 'transparent',
      strokeWidth: 12
    },
    edgeHighlight: {
      stroke: theme.color.blue.l1,
      strokeWidth: 3.5,
      markerEnd: 'url(#arrow-highlight)',
      opacity: 1
    },
    edgeLowlight: {
      stroke: theme.color.gray.d1,
      markerEnd: 'url(#arrow-lowlight)',
      opacity: 0.5
    },
    edgeSelected: {
      stroke: theme.color.blue.d2,
      strokeWidth: 3.5,
      markerEnd: 'url(#arrow-selected)'
    },
    edgeLabel: {
      opacity: 1,
      textAlign: 'right',
      fontSize: theme.typography.caption.fontSize,
      fontFamily: theme.typography.caption.fontFamily,
      fontWeight: theme.typography.caption.fontWeight,
      pointerEvents: 'none'
    },
    edgeLabelHighlight: {
      opacity: 1
    },
    edgeLabelLowlight: {
      opacity: 0.5
    },
    edgeLabelSelected: {
      opacity: 1
    }
  });
};

var DagEdgeComponent = withStyles(styles$a, {
  defaultTheme: defaultTheme
})(DagEdge);
var kRadius = 2;
var kLabelShift = 3;

var DagPort =
/*#__PURE__*/
function (_PureComponent12) {
  _inherits(DagPort, _PureComponent12);

  function DagPort() {
    _classCallCheck(this, DagPort);

    return _possibleConstructorReturn(this, _getPrototypeOf(DagPort).apply(this, arguments));
  }

  _createClass(DagPort, [{
    key: "render",
    value: function render() {
      var _this$props17 = this.props,
          x = _this$props17.x,
          y = _this$props17.y,
          light = _this$props17.light,
          label = _this$props17.label,
          classes = _this$props17.classes;
      return createElement("g", null, createElement("circle", {
        cx: x,
        cy: y,
        r: kRadius
      }), label !== undefined && (light === "highlight" || light === "selected") ? createElement("text", {
        transform: "translate(".concat(x + kLabelShift, ",").concat(y - kLabelShift, ")rotate(315)"),
        className: classes.label
      }, label) : null);
    }
  }]);

  return DagPort;
}(PureComponent);

var styles$b = function styles$b(theme) {
  return createStyles({
    label: {
      fontSize: theme.typography.caption.fontSize,
      fontFamily: theme.typography.caption.fontFamily,
      fontWeight: theme.typography.caption.fontWeight,
      fill: theme.typography.caption.color
    }
  });
};

var DagPortComponent = withStyles(styles$b, {
  defaultTheme: defaultTheme
})(DagPort);
/**
 * Utility functions to manipulate common data structures.
 */
// TODO: Implement functions for `Map` (keys not limited to strings).
// TODO: Annotate with better types (e.g. using generics, $ObjMap, etc).

/**
 * Transform key-value pairs in an object into new key-value pairs, or `undefined` to omit.
 *     let obj = { 1: 1, 2: 2, 3: 3 };
 *     obj2obj(obj, (k, v, i) => [k, v * 2]);
 *     >> { 1: 2, 2: 4, 3: 6 }
 */

function obj2obj(obj, transform) {
  return pairs2obj(Object.entries(obj).map(function (_ref8, i) {
    var _ref9 = _slicedToArray(_ref8, 2),
        k = _ref9[0],
        v = _ref9[1];

    return transform(k, v, i);
  }).filter(function (pair) {
    return pair !== undefined;
  }));
}
/**
 * Transform key-value pairs in a map into new key-value pairs, or `undefined` to omit.
 *     let obj = { 1: 1, 2: 2, 3: 3 };
 *     obj2obj(obj, (k, v, i) => [k, v * 2]);
 *     >> { 1: 2, 2: 4, 3: 6 }
 */


function map2obj(map, transform) {
  return pairs2obj(Array.from(map.entries()).map(function (_ref10, i) {
    var _ref11 = _slicedToArray(_ref10, 2),
        k = _ref11[0],
        v = _ref11[1];

    return transform(k, v, i);
  }).filter(function (pair) {
    return pair !== undefined;
  }));
}
/**
 * Transform key-value pairs in an object into elements of an array, or `undefined` to omit.
 *     let obj = { 1: 4, 2: 3, 3: 2 };
 *     obj2arr(obj, (k, v, i) => Number(k) + v);
 *     >> [5, 5, 5]
 */


function obj2arr(obj, transform) {
  return Object.entries(obj).map(function (_ref12, i) {
    var _ref13 = _slicedToArray(_ref12, 2),
        k = _ref13[0],
        v = _ref13[1];

    return transform(k, v, i);
  }).filter(function (elem) {
    return elem !== undefined;
  });
}
/**
 * Transform array of pairs into key-value pairs in an object.
 *     let pairs = [["1", 1], ["2", 2]];
 *     pairs2obj(pairs);
 *     >> { 1: 1, 2: 2 }
 */


function pairs2obj(pairs) {
  return pairs.reduce(function (obj, _ref14) {
    var _ref15 = _slicedToArray(_ref14, 2),
        k = _ref15[0],
        v = _ref15[1];

    obj[k] = v;
    return obj;
  }, {});
} // const ctx: Worker = self as any;
//     ctx.addEventListener('message', (e) => {


function workerFn(msg) {
  var _msg$data = msg.data,
      nodeSchemas = _msg$data.nodeSchemas,
      edgeSchemas = _msg$data.edgeSchemas,
      alignments = _msg$data.alignments;

  var _fromSchema = fromSchema(nodeSchemas, edgeSchemas),
      allNodes = _fromSchema.nodes,
      allEdges = _fromSchema.edges;

  var allStorage = new StructuredStorage(allNodes, allEdges); // alignments.forEach((alignment: any) => {
  //     const sets = alignmentSets[alignment.axis as 'x' | 'y'];
  //     let found = false;
  //     for (let set of sets) {
  //         if (alignment.nodes.some((nodeId: any) => set.has(nodeId))) {
  //             found = true;
  //             alignment.nodes.forEach((nodeId: any) => set.add(nodeId));
  //             break;
  //         }
  //     }
  //     if (!found) {
  //         sets.push(new Set(alignment.nodes));
  //     }
  // });
  // =========================================================================================
  // Perform layout.

  var visibleStorage = new StructuredStorage(allNodes, allEdges);
  var shortestPath = visibleStorage.shortestPaths();

  var lengthFn = function lengthFn(u, v, edge) {
    // TODO: alignment axis
    // if (!visibleStorage.siblings(u).has(v)) {
    //     return -1;
    // }
    return 20;
  };

  var layout = new StagedLayout(visibleStorage, {
    steps: 200
  }, {
    iterations: 1,
    optimizer: new BasicOptimizer(0.5),
    generator:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function generator(storage) {
      var elems;
      return _regeneratorRuntime.wrap(function generator$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              elems = storage;
              return _context.delegateYield(generateSpringForcesCompound(elems, lengthFn, shortestPath, {
                maxAttraction: 100
              }), "t0", 2);

            case 2:
              return _context.delegateYield(generateCompactnessForces(storage, 0), "t1", 3);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, generator);
    })
  }, {
    iterations: 5,
    optimizer: new BasicOptimizer(1),
    generator:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function generator(storage, step) {
      var elems, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref17, source, target, meta, axis, gda, _gda, u, v, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, sibling, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _u;

      return _regeneratorRuntime.wrap(function generator$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              elems = storage;

              if (!(step > 10)) {
                _context2.next = 47;
                break;
              }

              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context2.prev = 5;
              _iterator = storage.edges()[Symbol.iterator]();

            case 7:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context2.next = 33;
                break;
              }

              _ref17 = _step.value;
              source = _ref17.source;
              target = _ref17.target;
              meta = _ref17.meta;
              // if (elems.hasAncestorOrDescendant(source.node, target.node)) {
              //     continue;
              // }
              axis = void 0;
              _context2.t0 = meta.flowDirection;
              _context2.next = _context2.t0 === "north" ? 16 : _context2.t0 === "south" ? 18 : _context2.t0 === "west" ? 20 : _context2.t0 === "east" ? 22 : 24;
              break;

            case 16:
              axis = [0, -1];
              return _context2.abrupt("break", 24);

            case 18:
              axis = [0, 1];
              return _context2.abrupt("break", 24);

            case 20:
              axis = [-1, 0];
              return _context2.abrupt("break", 24);

            case 22:
              axis = [1, 0];
              return _context2.abrupt("break", 24);

            case 24:
              gda = elems.greatestDifferentAncestor(source.node, target.node);

              if (!(gda === undefined)) {
                _context2.next = 27;
                break;
              }

              return _context2.abrupt("continue", 30);

            case 27:
              _gda = _slicedToArray(gda, 2), u = _gda[0], v = _gda[1];
              _context2.next = 30;
              return constrainNodeOffset(u, v, ">=", 30, axis);

            case 30:
              _iteratorNormalCompletion = true;
              _context2.next = 7;
              break;

            case 33:
              _context2.next = 39;
              break;

            case 35:
              _context2.prev = 35;
              _context2.t1 = _context2["catch"](5);
              _didIteratorError = true;
              _iteratorError = _context2.t1;

            case 39:
              _context2.prev = 39;
              _context2.prev = 40;

              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }

            case 42:
              _context2.prev = 42;

              if (!_didIteratorError) {
                _context2.next = 45;
                break;
              }

              throw _iteratorError;

            case 45:
              return _context2.finish(42);

            case 46:
              return _context2.finish(39);

            case 47:
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context2.prev = 50;
              _iterator2 = storage.nodes()[Symbol.iterator]();

            case 52:
              if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                _context2.next = 85;
                break;
              }

              u = _step2.value;

              if (!(step > 100)) {
                _context2.next = 81;
                break;
              }

              _iteratorNormalCompletion4 = true;
              _didIteratorError4 = false;
              _iteratorError4 = undefined;
              _context2.prev = 58;
              _iterator4 = elems.siblings(u)[Symbol.iterator]();

            case 60:
              if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                _context2.next = 67;
                break;
              }

              sibling = _step4.value;
              _context2.next = 64;
              return constrainNodeNonoverlap(u, sibling, 20);

            case 64:
              _iteratorNormalCompletion4 = true;
              _context2.next = 60;
              break;

            case 67:
              _context2.next = 73;
              break;

            case 69:
              _context2.prev = 69;
              _context2.t2 = _context2["catch"](58);
              _didIteratorError4 = true;
              _iteratorError4 = _context2.t2;

            case 73:
              _context2.prev = 73;
              _context2.prev = 74;

              if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                _iterator4.return();
              }

            case 76:
              _context2.prev = 76;

              if (!_didIteratorError4) {
                _context2.next = 79;
                break;
              }

              throw _iteratorError4;

            case 79:
              return _context2.finish(76);

            case 80:
              return _context2.finish(73);

            case 81:
              return _context2.delegateYield(generateNodeChildrenConstraints(u, 10), "t3", 82);

            case 82:
              _iteratorNormalCompletion2 = true;
              _context2.next = 52;
              break;

            case 85:
              _context2.next = 91;
              break;

            case 87:
              _context2.prev = 87;
              _context2.t4 = _context2["catch"](50);
              _didIteratorError2 = true;
              _iteratorError2 = _context2.t4;

            case 91:
              _context2.prev = 91;
              _context2.prev = 92;

              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }

            case 94:
              _context2.prev = 94;

              if (!_didIteratorError2) {
                _context2.next = 97;
                break;
              }

              throw _iteratorError2;

            case 97:
              return _context2.finish(94);

            case 98:
              return _context2.finish(91);

            case 99:
              _iteratorNormalCompletion3 = true;
              _didIteratorError3 = false;
              _iteratorError3 = undefined;
              _context2.prev = 102;
              _iterator3 = storage.nodes()[Symbol.iterator]();

            case 104:
              if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                _context2.next = 110;
                break;
              }

              _u = _step3.value;
              return _context2.delegateYield(generateNodePortConstraints(_u, 0.5, 16), "t5", 107);

            case 107:
              _iteratorNormalCompletion3 = true;
              _context2.next = 104;
              break;

            case 110:
              _context2.next = 116;
              break;

            case 112:
              _context2.prev = 112;
              _context2.t6 = _context2["catch"](102);
              _didIteratorError3 = true;
              _iteratorError3 = _context2.t6;

            case 116:
              _context2.prev = 116;
              _context2.prev = 117;

              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
              }

            case 119:
              _context2.prev = 119;

              if (!_didIteratorError3) {
                _context2.next = 122;
                break;
              }

              throw _iteratorError3;

            case 122:
              return _context2.finish(119);

            case 123:
              return _context2.finish(116);

            case 124:
            case "end":
              return _context2.stop();
          }
        }
      }, generator, null, [[5, 35, 39, 47], [40,, 42, 46], [50, 87, 91, 99], [58, 69, 73, 81], [74,, 76, 80], [92,, 94, 98], [102, 112, 116, 124], [117,, 119, 123]]);
    })
  });
  layout.start(); // =========================================================================================
  // Retarget edges from center points to boundary points.

  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = visibleStorage.edges()[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var edge = _step5.value;
      var start = edge.path[0];
      var end = edge.path[edge.path.length - 1];

      if (edge.source.node.ports[edge.source.port].location === 'center') {
        start.copy(edge.source.node.shape.boundary(new Vector().subVectors(end, start)));
        edge.source.node.ports[edge.source.port].location = 'boundary';
        edge.source.node.ports[edge.source.port].point.copy(start);
      }

      if (edge.target.node.ports[edge.target.port].location === 'center') {
        end.copy(edge.target.node.shape.boundary(new Vector().subVectors(start, end)));
        edge.target.node.ports[edge.target.port].location = 'boundary';
        edge.target.node.ports[edge.target.port].point.copy(end);
      }
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  var router = new OrthogonalRouter(visibleStorage, {
    nodeMargin: 16
  });
  router.route();
  return {
    data: Object.assign(Object.assign({}, toSchema(visibleStorage.nodes(), visibleStorage.edges())), {
      bounds: visibleStorage.bounds()
    })
  }; // const {nodeSchemas, edgeSchemas} = toSchema(Array.from(storage.nodes()), Array.from(storage.edges()));
  // ctx.postMessage(({nodeSchemas, edgeSchemas, bounds: elems.bounds(), ordering}));
} // TODO: uncomment this when running storybook
// import MyWorker from 'worker-loader!./worker'
// TODO: uncomment this when running a build
// import MyWorker from 'web-worker:./worker';

/**
 * This pure dumb component renders a directed acyclic graph.
 */


var kNodeGroupDefaultSize = 10;
var kNodeLeafDefaultSize = 10000;
var kNodeResizeTolerance = 5;
var kGraphPadding = 10;

var DagLayout =
/*#__PURE__*/
function (_Component) {
  _inherits(DagLayout, _Component);

  function DagLayout(props) {
    var _this21;

    _classCallCheck(this, DagLayout);

    _this21 = _possibleConstructorReturn(this, _getPrototypeOf(DagLayout).call(this, props)); // Count how many resize state updates have not been committed yet.

    _this21.resizes = 0;
    _this21._childViewers = new Map();
    _this21._childViewerCallbacks = new Map(); // TODO: Set expansion to true iff has children (also take into account isExpanded).

    var nodeExpansions = Map$1(obj2arr(_this21.props.nodes, function (nodeId, node) {
      return [nodeId, node.isExpanded !== false && node.children.length > 0];
    }));
    _this21.state = Object.assign(Object.assign({}, _this21.calculateGraphElements(_this21.props.nodes, _this21.props.edges, _this21.props.alignments, nodeExpansions, Map$1(), Map$1())), {
      bounds: {
        width: 0,
        height: 0,
        x: 0,
        X: 0,
        y: 0,
        Y: 0
      },
      nodeExpansions: nodeExpansions,
      nodeStates: Map$1(obj2arr(_this21.props.nodes, function (nodeId) {
        return [nodeId, {
          light: 'normal'
        }];
      })),
      edgeStates: Map$1(obj2arr(_this21.props.edges, function (edgeId) {
        return [edgeId, {
          light: 'normal'
        }];
      })),
      selectedNodeId: "".concat(Object.keys(_this21.props.nodes)[0])
    }); // Bind methods for ref callbacks.

    _this21._getChildViewerCallback.bind(_assertThisInitialized(_this21));

    console.log('constructor', _this21.state.nodes);
    return _this21;
  }

  _createClass(DagLayout, [{
    key: "calculateGraphElements",
    value: function calculateGraphElements(allNodes, allEdges, allAlignments, nodeExpansions, prevNodes, prevEdges) {
      var _this22 = this;

      // TODO: Selectorize.
      var allParents = new Map();
      Object.entries(allNodes).forEach(function (_ref18) {
        var _ref19 = _slicedToArray(_ref18, 2),
            nodeId = _ref19[0],
            node = _ref19[1];

        return node.children.forEach(function (childId) {
          return allParents.set(childId, nodeId);
        });
      });
      var allRoots = Object.keys(allNodes).filter(function (nodeId) {
        return allParents.get(nodeId) === undefined;
      });
      var visibleOrdering = []; // Compute visible nodes.

      var visibleNodes = new Map();
      var visiblePorts = [];

      var traverse = function traverse(nodeId) {
        visibleOrdering.push({
          type: 'node',
          id: nodeId
        });
        var prevNode = prevNodes.get(nodeId);
        var nodeExpanded = nodeExpansions.get(nodeId); // Only true if has children.

        var nodeDefaultSize = nodeExpanded ? kNodeGroupDefaultSize : kNodeLeafDefaultSize;
        visibleNodes.set(nodeId, {
          id: nodeId,
          shape: {
            type: 'rectangle',
            width: prevNode ? prevNode.shape.width : nodeDefaultSize,
            height: prevNode ? prevNode.shape.height : nodeDefaultSize
          },
          // TODO: Change port schema to use location, as in nodal.
          ports: prevNode ? prevNode.ports : obj2obj(allNodes[nodeId].ports || {}, function (name, port) {
            return [name, {
              location: port.side,
              order: port.order
            }];
          }),
          meta: {
            alignChildren: allNodes[nodeId].alignChildren || _this22.props.alignChildren
          },
          children: nodeExpanded ? allNodes[nodeId].children : []
        });
        visiblePorts.push(Object.keys(visibleNodes.get(nodeId).ports).map(function (name) {
          return {
            type: 'port',
            nodeId: nodeId,
            name: name
          };
        }));

        if (nodeExpansions.get(nodeId)) {
          // Show children of expanded node.
          allNodes[nodeId].children.forEach(function (childId) {
            return traverse(childId);
          });
        }
      };

      allRoots.forEach(function (root) {
        return traverse(root);
      }); // Compute visible edges.

      var visibleEdges = new Map();
      Object.entries(allEdges).forEach(function (_ref20) {
        var _ref21 = _slicedToArray(_ref20, 2),
            edgeId = _ref21[0],
            edge = _ref21[1];

        if (visibleNodes.has(edge.source.id) && visibleNodes.has(edge.target.id)) {
          visibleOrdering.push({
            type: 'edge',
            id: edgeId
          });
          visibleEdges.set(edgeId, {
            id: edgeId,
            source: {
              id: edge.source.id,
              port: edge.source.port
            },
            target: {
              id: edge.target.id,
              port: edge.target.port
            },
            meta: {
              // TODO: use isPersistent flags to create new edges
              isSourcePersistent: edge.source.isPersistent,
              isTargetPersistent: edge.target.isPersistent
            }
          });
        }
      }); // Set `flowDirection` on each node based on ancestors by traversing containment hierarchy.

      var _fromSchema2 = fromSchema(Array.from(visibleNodes.values()), Array.from(visibleEdges.values())),
          nodes = _fromSchema2.nodes,
          edges = _fromSchema2.edges;

      var storage = new StructuredStorage(nodes, edges);

      var flowTraverse = function flowTraverse(u, ancestorDirection) {
        var flowDirection = allNodes[u.id].flowDirection || ancestorDirection;
        u.meta.flowDirection = flowDirection;
        u.children.forEach(function (child) {
          return flowTraverse(child, flowDirection);
        });
      };

      storage.roots().forEach(function (node) {
        return flowTraverse(node, _this22.props.flowDirection);
      }); // Set `flowDirection` on each edge based on least common ancestor of their source
      // and target nodes.

      storage.edges().forEach(function (edge) {
        var lca = storage.leastCommonAncestor(edge.source.node, edge.target.node);

        if (lca !== undefined) {
          edge.meta.flowDirection = lca.meta.flowDirection;
        } else {
          edge.meta.flowDirection = _this22.props.flowDirection;
        }
      });
      return {
        nodes: Map$1(visibleNodes),
        edges: Map$1(visibleEdges),
        ordering: List([visibleOrdering, visiblePorts.flat()].flat())
      };
    }
  }, {
    key: "_getChildViewerCallback",
    value: function _getChildViewerCallback(nodeId) {
      var _this23 = this;

      // TODO: What happens when I delete a Viewer (e.g. through hiding)?
      if (!this._childViewerCallbacks.get(nodeId)) {
        this._childViewerCallbacks.set(nodeId, function (viewer) {
          return _this23._childViewers.set(nodeId, viewer);
        });
      }

      return this._childViewerCallbacks.get(nodeId);
    }
  }, {
    key: "getHandle",
    value: function getHandle() {
      var _this24 = this;

      var selectedNodeId = this.state.selectedNodeId;
      return {
        nodes: map2obj(this._childViewers, function (k, v) {
          return v ? [k, v.viewerId] : undefined;
        }),
        selectedNodeId: selectedNodeId,
        doSelectNode: function doSelectNode(nodeId) {
          return _this24.setState({
            selectedNodeId: nodeId
          });
        },
        doSelectNeighborNode: function doSelectNeighborNode(direction) {// TODO
        },
        doSetLightNode: function doSetLightNode(nodeId, light) {
          return _this24.setState(function (state) {
            return {
              nodeStates: state.nodeStates.setIn([nodeId, 'light'], light)
            };
          });
        },
        doSetLightEdge: function doSetLightEdge(edgeId, light) {
          return _this24.setState(function (state) {
            return {
              edgeStates: state.edgeStates.setIn([edgeId, 'light'], light)
            };
          });
        },
        doToggleNodeExpanded: function doToggleNodeExpanded(nodeId) {
          return _this24.setState(function (state) {
            var nodeExpansions = state.nodeExpansions.set(nodeId, _this24.props.nodes[nodeId].children.length > 0 ? !state.nodeExpansions.get(nodeId) : false);
            return Object.assign(Object.assign({}, _this24.calculateGraphElements(_this24.props.nodes, _this24.props.edges, _this24.props.alignments, nodeExpansions, state.nodes, state.edges)), {
              nodeExpansions: nodeExpansions
            });
          });
        },
        doSetNodeExpanded: function doSetNodeExpanded(nodeId, expanded) {
          return _this24.setState(function (state) {
            var nodeExpansions = state.nodeExpansions.set(nodeId, _this24.props.nodes[nodeId].children.length > 0 ? expanded : false);
            return Object.assign(Object.assign({}, _this24.calculateGraphElements(_this24.props.nodes, _this24.props.edges, _this24.props.alignments, nodeExpansions, state.nodes, state.edges)), {
              nodeExpansions: nodeExpansions
            });
          });
        }
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // At this point, we have the sizes of the unlayouted nodes.
      console.debug('DagLayout -- componentDidMount(): mounted');
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // Performing the layout will change the state, so we wrap it in a condition to prevent
      // infinite looping.
      console.log('DagLayout -- componentDidUpdate()');
      var _this$props$interacti5 = this.props.interactions,
          viewerId = _this$props$interacti5.viewerId,
          emit = _this$props$interacti5.emit;
      var _this$state3 = this.state,
          selectedNodeId = _this$state3.selectedNodeId,
          nodeStates = _this$state3.nodeStates,
          nodeExpansions = _this$state3.nodeExpansions,
          edgeStates = _this$state3.edgeStates;

      if (selectedNodeId !== prevState.selectedNodeId) {
        emit('Dag.DidSelectNode', {
          viewerId: viewerId,
          selectedNodeId: selectedNodeId,
          prevSelectedNodeId: prevState.selectedNodeId
        });
      }

      if (nodeStates !== prevState.nodeStates) {
        Array.from(nodeStates.entries()).forEach(function (_ref22) {
          var _ref23 = _slicedToArray(_ref22, 2),
              nodeId = _ref23[0],
              light = _ref23[1].light;

          var prevNodeState = prevState.nodeStates.get(nodeId);
          if (prevNodeState === undefined) return;
          var prevLight = prevNodeState.light;

          if (prevLight !== light) {
            emit('Dag.NodeDidChangeLight', {
              viewerId: viewerId,
              nodeId: nodeId,
              light: light
            });
          }
        });
      }

      if (nodeExpansions !== prevState.nodeExpansions) {
        Array.from(nodeExpansions.entries()).forEach(function (_ref24) {
          var _ref25 = _slicedToArray(_ref24, 2),
              nodeId = _ref25[0],
              expanded = _ref25[1];

          var prevExpanded = prevState.nodeExpansions.get(nodeId);
          if (prevExpanded === undefined) return;

          if (prevExpanded !== expanded) {
            emit('Dag.NodeDidResize', {
              viewerId: viewerId,
              nodeId: nodeId,
              expanded: expanded
            });
          }
        });
      }

      if (edgeStates !== prevState.edgeStates) {
        Array.from(edgeStates.entries()).forEach(function (_ref26) {
          var _ref27 = _slicedToArray(_ref26, 2),
              edgeId = _ref27[0],
              light = _ref27[1].light;

          var prevEdgeState = prevState.edgeStates.get(edgeId);
          if (prevEdgeState === undefined) return;
          var prevLight = prevEdgeState.light;

          if (prevLight !== light) {
            emit('Dag.EdgeDidChangeLight', {
              viewerId: viewerId,
              edgeId: edgeId,
              light: light
            });
          }
        });
      }
    }
    /**
     * Callback function to update a node's size dimensions (upon interacting with its `Viewer`).
     * @param nodeId
     * @param width
     * @param height
     * @private
     */

  }, {
    key: "_onNodeResize",
    value: function _onNodeResize(nodeId, width, height) {
      var _this25 = this;

      var prevWidth = this.state.nodes.get(nodeId).shape.width;
      var prevHeight = this.state.nodes.get(nodeId).shape.height;

      if (prevWidth !== undefined && prevHeight !== undefined && Math.abs(prevWidth - width) < kNodeResizeTolerance && Math.abs(prevHeight - height) < kNodeResizeTolerance) {
        return;
      }

      console.log("DagLayout -- _onNodeResize(".concat(nodeId, ", ").concat(width, ", ").concat(height, ", ").concat(prevWidth, ", ").concat(prevHeight, ")"));
      this.resizes += 1;
      this.setState(function (state) {
        console.log("resize queued from ".concat(nodeId));
        return {
          nodes: state.nodes.mergeIn([nodeId], {
            shape: {
              type: 'rectangle',
              width: width,
              height: height
            }
          })
        };
      }, function () {
        _this25.resizes -= 1;
        console.log("resize saved from ".concat(nodeId));

        if (_this25.resizes === 0) {
          console.log("resize counter reached 0");

          _this25._layoutGraph();
        }
      });
    }
    /**
     * Layout the graph using the current size dimensions.
     * @private
     */

  }, {
    key: "_layoutGraph",
    value: function _layoutGraph() {
      var _this26 = this;

      console.log("_layoutGraph", this.state.nodes, this.state.nodeStates); // const worker = new MyWorker();

      var layoutCallback = function layoutCallback(e) {
        var _e$data = e.data,
            nodeSchemas = _e$data.nodeSchemas,
            edgeSchemas = _e$data.edgeSchemas,
            bounds = _e$data.bounds;

        _this26.setState(function (state) {
          return {
            nodes: Map$1(nodeSchemas.map(function (ns) {
              return [ns.id, ns];
            })),
            edges: Map$1(edgeSchemas.map(function (es) {
              return [es.id, es];
            })),
            bounds: {
              x: bounds.x - kGraphPadding,
              y: bounds.y - kGraphPadding,
              X: bounds.X + kGraphPadding,
              Y: bounds.Y + kGraphPadding,
              width: bounds.width + kGraphPadding * 2,
              height: bounds.height + kGraphPadding * 2
            }
          };
        });
      }; // worker.onmessage = laid
      // worker.postMessage({


      var results = workerFn({
        data: {
          nodeSchemas: Array.from(this.state.nodes.values()),
          edgeSchemas: Array.from(this.state.edges.values()),
          alignments: this.props.alignments || []
        }
      });
      layoutCallback(results);
    }
    /**
     * Renders a DAG with nodes and edges. Nodes can contain `Viewer` objects or other nodes,
     * depending on expansion mode. Edges can have string labels.
     */

  }, {
    key: "render",
    value: function render() {
      var _this27 = this;

      var _this$props18 = this.props,
          classes = _this$props18.classes,
          passdown = _this$props18.passdown,
          interactions = _this$props18.interactions,
          light = _this$props18.light;
      var mouseHandlers = interactions.mouseHandlers,
          viewerId = interactions.viewerId,
          emit = interactions.emit;
      var _this$state4 = this.state,
          ordering = _this$state4.ordering,
          bounds = _this$state4.bounds,
          nodeStates = _this$state4.nodeStates,
          nodeExpansions = _this$state4.nodeExpansions,
          edgeStates = _this$state4.edgeStates;
      console.log('DagLayout -- render(): ordering =', ordering, 'state =', this.state);

      function buildArrowMarker(id, className) {
        return createElement("marker", {
          key: id,
          id: id,
          viewBox: '0 0 10 10',
          refX: '4',
          refY: '5',
          markerUnits: 'strokeWidth',
          markerWidth: '4',
          markerHeight: '4',
          orient: 'auto'
        }, createElement("path", {
          d: 'M 0 0 L 10 5 L 0 10 L 4 5 z',
          className: className
        }));
      }

      function buildNodeMouseHandlers(nodeId) {
        var message = {
          viewerId: viewerId,
          nodeId: nodeId
        };
        return {
          onClick: function onClick(e) {
            e.stopPropagation();
            emit('Dag.NodeDidClick', message);
          },
          onDoubleClick: function onDoubleClick(e) {
            e.stopPropagation();
            emit('Dag.NodeDidDoubleClick', message);
          },
          onMouseOver: function onMouseOver(e) {
            e.stopPropagation();
            emit('Dag.NodeDidMouseOver', message);
          },
          onMouseOut: function onMouseOut(e) {
            e.stopPropagation();
            emit('Dag.NodeDidMouseOut', message);
          }
        };
      }

      function buildEdgeMouseHandlers(edgeId) {
        var message = {
          viewerId: viewerId,
          edgeId: edgeId
        };
        return {
          onClick: function onClick(e) {
            e.stopPropagation();
            emit('Dag.EdgeDidClick', message);
          },
          onDoubleClick: function onDoubleClick(e) {
            e.stopPropagation();
            emit('Dag.EdgeDidDoubleClick', message);
          },
          onMouseOver: function onMouseOver(e) {
            e.stopPropagation();
            emit('Dag.EdgeDidMouseOver', message);
          },
          onMouseOut: function onMouseOut(e) {
            e.stopPropagation();
            emit('Dag.EdgeDidMouseOut', message);
          }
        };
      }

      var lightEdges = [];
      return createElement(Frame$1, {
        component: 'div',
        style: 'framed',
        light: light,
        mouseHandlers: mouseHandlers
      }, bounds.width === 0 ? createElement(CircularProgress, null) : null, createElement("div", {
        className: classes.graph
      }, createElement("svg", {
        viewBox: bounds ? "".concat(bounds.x, " ").concat(bounds.y, " ").concat(bounds.width, " ").concat(bounds.height) : undefined,
        width: bounds ? "".concat(bounds.width) : '100%',
        height: bounds ? "".concat(bounds.height) : '100%'
      }, createElement("defs", null, [buildArrowMarker('arrow-normal', classes.arrowNormal), buildArrowMarker('arrow-highlight', classes.arrowHighlight), buildArrowMarker('arrow-lowlight', classes.arrowLowlight), buildArrowMarker('arrow-selected', classes.arrowSelected)]), createElement("rect", {
        x: bounds.x,
        y: bounds.y,
        width: bounds.width,
        height: bounds.height,
        fill: 'transparent',
        onClick: undefined
      }), ordering.map(function (elem) {
        switch (elem.type) {
          case 'node':
            {
              var id = elem.id;
              var _this27$props$nodes$i = _this27.props.nodes[id],
                  fragmentId = _this27$props$nodes$i.fragmentId,
                  label = _this27$props$nodes$i.label,
                  isInteractive = _this27$props$nodes$i.isInteractive,
                  isVisible = _this27$props$nodes$i.isVisible;

              var _this27$state$nodes$g = _this27.state.nodes.get(id),
                  center = _this27$state$nodes$g.center,
                  shape = _this27$state$nodes$g.shape;

              return createElement(DagNodeComponent, {
                key: "n-".concat(id),
                x: center ? center.x : 0,
                y: center ? center.y : 0,
                width: shape.width,
                height: shape.height,
                label: label,
                isExpanded: nodeExpansions.get(id) === true,
                isInteractive: isInteractive !== false && _this27.props.nodes[id].children.length !== 0,
                isVisible: isVisible,
                light: nodeStates.get(id).light,
                onResize: function onResize(width, height) {
                  return _this27._onNodeResize(id, width, height);
                },
                mouseHandlers: buildNodeMouseHandlers(id)
              }, createElement(Viewer, Object.assign({
                ref: _this27._getChildViewerCallback(id)
              }, passdown, {
                fragmentId: fragmentId
              })));
            }

          case 'edge':
            {
              var _id = elem.id;

              var _this27$state$edges$g = _this27.state.edges.get(_id),
                  path = _this27$state$edges$g.path;

              var _light = edgeStates.get(_id).light;

              if (_light === 'highlight' || _light === 'selected') {
                lightEdges.push(elem);
                return null;
              }

              return createElement(DagEdgeComponent, {
                key: "e-".concat(_id),
                points: path || [],
                light: edgeStates.get(_id).light,
                temporal: _this27.props.edges[_id].temporal,
                mouseHandlers: buildEdgeMouseHandlers(_id)
              });
            }

          case 'port':
            {
              var nodeId = elem.nodeId,
                  name = elem.name;
              var _label = _this27.props.nodes[nodeId].ports[name].label;

              var point = _this27.state.nodes.get(nodeId).ports[name].point;

              if (point === undefined) {
                return null;
              }

              return createElement(DagPortComponent, {
                key: "p-".concat(nodeId, "-").concat(name),
                x: point.x,
                y: point.y,
                label: _label,
                light: nodeStates.get(nodeId).light
              });
            }

          default:
            console.error('Got unrecognized graph element:', elem);
            return null;
        }
      }), lightEdges.map(function (elem) {
        var id = elem.id;

        var _this27$state$edges$g2 = _this27.state.edges.get(id),
            path = _this27$state$edges$g2.path;

        return createElement(DagEdgeComponent, {
          key: "e-".concat(id),
          points: path || [],
          light: edgeStates.get(id).light,
          temporal: _this27.props.edges[id].temporal,
          mouseHandlers: buildEdgeMouseHandlers(id)
        });
      }))));
    }
  }]);

  return DagLayout;
}(Component); // Initial layout:
//     constructor(): Initialize state from props.
//     render(): Render invisibly the unlayouted nodes.
//     componentDidMount(): Since unlayouted nodes have been mounted, their size population
//         callbacks have be called. Once all sizes are populated, the layout engine is called
//         to perform the layout, which will `forceUpdate().
// After initial layout:
//     When existing dimensions changed, layout again.
//     When expansion state changes (revealing new nodes), render invisibly the unlayouted
//         nodes then perform a layout.
// 


DagLayout.defaultProps = {
  flowDirection: 'south',
  alignChildren: false
};

var styles$c = function styles$c(theme) {
  return createStyles({
    frame: {
      flex: 1,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'stretch',
      overflow: 'hidden'
    },
    graph: {
      flex: 'auto',
      overflow: 'auto',
      textAlign: 'left'
    },
    arrowNormal: {
      fill: theme.color.gray.d2
    },
    arrowHighlight: {
      fill: theme.color.blue.l1
    },
    arrowLowlight: {
      fill: theme.color.gray.d1
    },
    arrowSelected: {
      fill: theme.color.blue.d2
    }
  });
};

var DagLayout$1 = withStyles(styles$c, {
  defaultTheme: defaultTheme
})(DagLayout);
/** A set of `ViewerHandle`s, which can be transformed using `filter()` and `map()` operations and
 * iterated over using `forEach()`. It surfaces commonly used operations for filtering on ids,
 * types, and metadata. */

var ViewerSelector =
/*#__PURE__*/
function () {
  function ViewerSelector(viewers) {
    _classCallCheck(this, ViewerSelector);

    this._selected = viewers;
  }
  /**
   * Keep only `Viewer`s with any of the specified `ViewerId`s.
   * @param ids
   */


  _createClass(ViewerSelector, [{
    key: "viewerId",
    value: function viewerId() {
      for (var _len = arguments.length, ids = new Array(_len), _key = 0; _key < _len; _key++) {
        ids[_key] = arguments[_key];
      }

      return this.filter(function (viewer) {
        return ids.includes(viewer.viewerId);
      });
    }
    /**
     * Keep only `Viewer`s rendering `Fragment`s with any of the specified `FragmentId`s.
     * @param ids
     */

  }, {
    key: "fragmentId",
    value: function fragmentId() {
      for (var _len2 = arguments.length, ids = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        ids[_key2] = arguments[_key2];
      }

      return this.filter(function (viewer) {
        return ids.includes(viewer.fragmentId);
      });
    }
    /**
     * Keep only `Viewer`s rendering `Fragment`s belonging to any of the specified types.
     * @param types
     */

  }, {
    key: "type",
    value: function type() {
      for (var _len3 = arguments.length, types = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        types[_key3] = arguments[_key3];
      }

      function fn(viewer) {
        return types.includes(viewer.type);
      }

      return new ViewerSelector(_.filter(this._selected, fn));
    }
    /**
     * Keep only `Viewer`s rendering `Fragment`s with any of the specified metadata.
     * @param metas
     *     A tuple of 2 elements: (1) string key name, (2) either a testing function that
     *     takes the value and returns whether to keep it, or a value which will be mathched
     *     through shallow equality.
     */

  }, {
    key: "meta",
    value: function meta() {
      for (var _len4 = arguments.length, metas = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        metas[_key4] = arguments[_key4];
      }

      return this.filter(function (viewer) {
        for (var _i = 0, _metas = metas; _i < _metas.length; _i++) {
          var _ref30 = _metas[_i];

          var _ref29 = _slicedToArray(_ref30, 2);

          var key = _ref29[0];
          var value = _ref29[1];

          if (key in viewer.meta) {
            if (value instanceof Function) {
              return value(viewer.meta[key]);
            } else {
              return value === viewer.meta[key];
            }
          }
        }
      });
    } // public mode(): ViewerSelector {
    //     return this.map((viewer) => viewer.selectedMode);
    // }

    /**
     * Map each `ViewerHandle` to a different `ViewerHandle`.
     * @param fn
     */

  }, {
    key: "map",
    value: function map(fn) {
      return new ViewerSelector(this._selected.map(fn));
    }
    /**
     * Filter the set of `ViewerHandle`s using a predicate function.
     * @param fn
     */

  }, {
    key: "filter",
    value: function filter(fn) {
      return new ViewerSelector(this._selected.filter(fn));
    }
    /**
     * Iterate over each `ViewerHandle` in the set.
     * @param fn
     */

  }, {
    key: "forEach",
    value: function forEach(fn) {
      this._selected.forEach(fn);
    }
  }]);

  return ViewerSelector;
}();
/** Configuration object used to define how user interactions should be handled by the `Viewer`s
 * and/or the external application. This `InteractionManager` adopts a Pub/Sub model for attaching
 * event handlers to different topics (i.e. channels for messages). By using `ViewerSelector`s and
 * `ViewerHandle`s, it is possible to target specific `Viewer`s to query and manipulate. */


var InteractionManager =
/*#__PURE__*/
function () {
  /**
   * @param options
   *     - `useMouseDefaults`: Whether to use default mouse interactions for hovering and
   *       selection.
   *     - `useKeyboardDefaults`: Whether to use default keyboard interactions for cursor
   *       navigation and selection.
   *     - `domElement`: DOM element on which to bind the keyboard listeners.
   */
  function InteractionManager() {
    var _this28 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, InteractionManager);

    // Maps a topic to the `EventHandler` functions that should fire when a message is emitted.
    this._handlers = {}; // Maps a `ViewerId` to a factory for its `ViewerHandle`. The factory will always produce a
    // valid `ViewerHandle` since its corresponding `Viewer` will have been mounted (as well as
    // the `Fragment` it renders).

    this._viewers = {}; // Global state that can be accessed by `EventHandler` functions.

    this._global = {}; // Queue of `Event`s that have been emitted but whose handlers have not yet been executed.

    this._eventQueue = []; // Whether the `InteractionManager` is currently executing the handlers for any event.

    this._isProcessingEvent = false;
    /**
     * Adds a `Viewer` to those accessible using a `ViewerSelector`. The `Viewer` must already
     * be mounted so that the `ViewerHandle` it produces is well-formed.
     */

    this.registerViewer = function (id, handleFactory) {
      _this28._viewers[id] = handleFactory;
    };
    /**
     * Removes a `Viewer` from those accessible using a `ViewerSelector`.
     */


    this.unregisterViewer = function (id) {
      delete _this28._viewers[id];
    };
    /**
     * Adds a new handler for a given topic.
     * @param topic
     * @param handler
     */


    this.on = function (topic, handler) {
      if (!(topic in _this28._handlers)) {
        _this28._handlers[topic] = [];
      }

      _this28._handlers[topic].push(handler);
    };
    /**
     * Enqueues a new `Event` to be processed. If no `Event` is currently being processed, then that
     * `Event` is processed immediately.
     * @param topic
     * @param message
     */


    this.emit = function (topic) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _this28._eventQueue.push({
        topic: topic,
        message: message
      });

      if (!_this28._isProcessingEvent) {
        _this28._processNextEvent();
      }
    };

    var _options$useMouseDefa = options.useMouseDefaults,
        useMouseDefaults = _options$useMouseDefa === void 0 ? true : _options$useMouseDefa,
        _options$useKeyboardD = options.useKeyboardDefaults,
        useKeyboardDefaults = _options$useKeyboardD === void 0 ? true : _options$useKeyboardD,
        _options$domElement = options.domElement,
        domElement = _options$domElement === void 0 ? document : _options$domElement;

    if (useMouseDefaults) {
      this._useMouseDefaults();
    }

    if (domElement) {
      domElement.addEventListener('keydown', function (e) {
        _this28.emit('KeyDown', {
          key: e.key
        });
      });
      domElement.addEventListener('keyup', function (e) {
        _this28.emit('KeyUp', {
          key: e.key
        });
      });
    } else {
      console.warn("Keyboard interactions needs 'domElement' to attach listeners to, instead got: ".concat(domElement));
    }

    if (useKeyboardDefaults) {
      this._useKeyboardDefaults();
    }

    if (useMouseDefaults || useKeyboardDefaults) {
      this._useLayoutHighlights();
    }
  }

  _createClass(InteractionManager, [{
    key: "_useLayoutHighlights",
    value: function _useLayoutHighlights() {
      this.on('Viewer.DidChangeLight', function (all, message, global) {
        if (message.viewerId === global.selected && message.light === 'selected') {
          all.viewerId(message.viewerId).forEach(function (viewer) {
            if (viewer.type === 'GridLayout') {
              all.viewerId(viewer.state.cells[viewer.state.selectedCellIdx]).forEach(function (child) {
                global.selectedChild = child.viewerId;
                child.appearance.doSetLight('highlight');
              });
            }

            if (viewer.type === 'FlowLayout') {
              all.viewerId(viewer.state.elements[viewer.state.selectedElementIdx]).forEach(function (child) {
                global.selectedChild = child.viewerId;
                child.appearance.doSetLight('highlight');
              });
            }

            if (viewer.type === 'SequenceLayout') {
              all.viewerId(viewer.state.elements[viewer.state.selectedElementIdx]).forEach(function (child) {
                global.selectedChild = child.viewerId;
                child.appearance.doSetLight('highlight');
              });
            }

            if (viewer.type === 'KeyValueLayout') {
              all.viewerId(viewer.state.entries[viewer.state.selectedEntryIdx][viewer.state.selectedEntryType]).forEach(function (child) {
                global.selectedChild = child.viewerId;
                child.appearance.doSetLight('highlight');
              });
            }

            if (viewer.type === 'SwitchLayout') {
              all.viewerId(viewer.state.mode).forEach(function (child) {
                global.selectedChild = child.viewerId;
                child.appearance.doSetLight('highlight');
              });
            }

            if (viewer.parentId) {
              all.viewerId(viewer.parentId).forEach(function (parent) {
                if (parent.type === 'GridLayout') {
                  parent.state.doSelectCell(parent.state.cells.findIndex(function (childId) {
                    return childId === viewer.viewerId;
                  }));
                }

                if (parent.type === 'FlowLayout') {
                  parent.state.doSelectElement(parent.state.elements.findIndex(function (childId) {
                    return childId === viewer.viewerId;
                  }));
                }

                if (parent.type === 'SequenceLayout') {
                  parent.state.doSelectElement(parent.state.elements.findIndex(function (childId) {
                    return childId === viewer.viewerId;
                  }));
                }

                if (parent.type === 'KeyValueLayout') {
                  parent.state.doSelectEntry(parent.state.entries.findIndex(function (_ref31) {
                    var key = _ref31.key,
                        value = _ref31.value;

                    if (key === viewer.viewerId) {
                      parent.state.doSelectKey();
                      return true;
                    }

                    if (value === viewer.viewerId) {
                      parent.state.doSelectValue();
                      return true;
                    }

                    return false;
                  }));
                }
              });
            }
          });
        }

        if (message.viewerId === global.prevSelected && message.light !== 'selected') {
          all.filter(function (viewer) {
            return viewer.parentId === global.prevSelected && viewer.appearance.light === 'highlight';
          }).forEach(function (viewer) {
            viewer.appearance.doSetLight('normal');
          });
        }
      });
      this.on('Grid.DidSelectCell', function (all, message, global) {
        if (global.selected === message.viewerId) {
          all.viewerId(message.viewerId).forEach(function (grid) {
            // TODO: correct typing here
            all.viewerId(grid.state.cells[message.prevSelectedCellIdx]).forEach(function (viewer) {
              return viewer.appearance.doSetLight('normal');
            });
            all.viewerId(grid.state.cells[message.selectedCellIdx]).forEach(function (viewer) {
              global.selectedChild = viewer.viewerId;
              viewer.appearance.doSetLight('highlight');
            });
          });
        }
      });
      this.on('Sequence.DidSelectElement', function (all, message, global) {
        if (global.selected === message.viewerId) {
          all.viewerId(message.viewerId).forEach(function (sequence) {
            // TODO: correct typing here
            all.viewerId(sequence.state.elements[message.prevSelectedElementIdx]).forEach(function (viewer) {
              return viewer.appearance.doSetLight('normal');
            });
            all.viewerId(sequence.state.elements[message.selectedElementIdx]).forEach(function (viewer) {
              global.selectedChild = viewer.viewerId;
              viewer.appearance.doSetLight('highlight');
            });
          });
        }
      });
      this.on('Flow.DidSelectElement', function (all, message, global) {
        if (global.selected === message.viewerId) {
          all.viewerId(message.viewerId).forEach(function (flow) {
            // TODO: correct typing here
            all.viewerId(flow.state.elements[message.prevSelectedElementIdx]).forEach(function (viewer) {
              return viewer.appearance.doSetLight('normal');
            });
            all.viewerId(flow.state.elements[message.selectedElementIdx]).forEach(function (viewer) {
              global.selectedChild = viewer.viewerId;
              viewer.appearance.doSetLight('highlight');
            });
          });
        }
      });
      this.on('KeyValue.DidSelectEntry', function (all, message, global) {
        if (global.selected === message.viewerId) {
          all.viewerId(message.viewerId).forEach(function (kv) {
            // TODO: correct typing here
            all.viewerId(kv.state.entries[message.prevSelectedEntryIdx][message.prevSelectedEntryType]).forEach(function (viewer) {
              return viewer.appearance.doSetLight('normal');
            });
            all.viewerId(kv.state.entries[message.selectedEntryIdx][message.selectedEntryType]).forEach(function (viewer) {
              global.selectedChild = viewer.viewerId;
              viewer.appearance.doSetLight('highlight');
            });
          });
        }
      });
    }
  }, {
    key: "_useMouseDefaults",
    value: function _useMouseDefaults() {
      this.on('Viewer.DidMouseOver', function (all, message, global) {
        global.hovered = message.viewerId;

        if (message.viewerId !== global.selected) {
          all.viewerId(message.viewerId).forEach(function (viewer) {
            viewer.appearance.doSetLight('highlight');
          });
        }
      });
      this.on('Viewer.DidMouseOut', function (all, message, global) {
        if (global.hovered === message.viewerId) {
          global.hovered = undefined;
        }

        if (message.viewerId !== global.selected && message.viewerId !== global.selectedChild) {
          all.viewerId(message.viewerId).forEach(function (viewer) {
            viewer.appearance.doSetLight('normal');
          });
        }
      });
      this.on('Viewer.DidClick', function (all, message, global) {
        if (message.viewerId !== global.selected) {
          all.viewerId(global.selected).forEach(function (viewer) {
            viewer.appearance.doSetLight('normal');
          });
          global.prevSelected = global.selected;
          global.selected = message.viewerId;
          all.viewerId(global.selected).forEach(function (viewer) {
            if (viewer.type === 'SwitchLayout' && viewer.appearance.light === 'selected') {
              viewer.state.doIncrementMode();
            }

            viewer.appearance.doSetLight('selected');
          });
        } else {
          all.viewerId(global.selected).forEach(function (viewer) {
            viewer.appearance.doSetLight('highlight');
          });
          global.selected = null;
        }
      }); // TODO: move default value filling somewhere else

      this.on('Dag.NodeDidMouseOver', function (all, message) {
        all.type('DagLayout').viewerId(message.viewerId).forEach(function (dag) {
          if (dag.contents.nodes[message.nodeId].isInteractive !== false) {
            dag.state.doSetLightNode(message.nodeId, 'highlight');
          }
        });
      });
      this.on('Dag.NodeDidMouseOut', function (all, message) {
        all.type('DagLayout').viewerId(message.viewerId).forEach(function (dag) {
          if (dag.contents.nodes[message.nodeId].isInteractive !== false) {
            dag.state.doSetLightNode(message.nodeId, 'normal');
          }
        });
      });
      this.on('Dag.NodeDidClick', function (all, message) {
        all.type('DagLayout').viewerId(message.viewerId).forEach(function (dag) {
          if (dag.contents.nodes[message.nodeId].isInteractive != false) {
            dag.state.doToggleNodeExpanded(message.nodeId);
            dag.state.doSetLightNode(message.nodeId, 'normal');
          }
        });
      });
      this.on('Dag.EdgeDidMouseOver', function (all, message) {
        all.type('DagLayout').viewerId(message.viewerId).forEach(function (dag) {
          dag.state.doSetLightEdge(message.edgeId, 'highlight');
        });
      });
      this.on('Dag.EdgeDidMouseOut', function (all, message) {
        all.type('DagLayout').viewerId(message.viewerId).forEach(function (dag) {
          dag.state.doSetLightEdge(message.edgeId, 'normal');
        });
      });
    }
  }, {
    key: "_useKeyboardDefaults",
    value: function _useKeyboardDefaults() {
      this.on('KeyDown', function (all, message, global) {
        all.viewerId(global.selected).forEach(function (viewer) {
          if (message.key === 'Escape') {
            if (viewer.parentId) {
              viewer.appearance.doSetLight('normal');
              global.prevSelected = global.selected;
              global.selected = viewer.parentId;
              all.viewerId(global.selected).forEach(function (viewer) {
                return viewer.appearance.doSetLight('selected');
              });
            }
          }

          switch (viewer.type) {
            case 'SwitchLayout':
              if (message.key === 'ArrowRight') {
                viewer.state.doIncrementMode();
              }

              if (message.key === 'ArrowLeft') {
                viewer.state.doIncrementMode(-1);
              }

              if (message.key === 'Enter') {
                viewer.appearance.doSetLight('normal');
                global.prevSelected = global.selected;
                global.selected = viewer.state.mode;
                all.viewerId(global.selected).forEach(function (viewer) {
                  return viewer.appearance.doSetLight('selected');
                });
              }

              break;

            case 'SequenceLayout':
              if (message.key === 'ArrowRight' || message.key === 'ArrowDown') {
                viewer.state.doIncrementElement();
              }

              if (message.key === 'ArrowLeft' || message.key === 'ArrowUp') {
                viewer.state.doIncrementElement(-1);
              }

              if (message.key === 'Enter') {
                viewer.appearance.doSetLight('normal');
                global.prevSelected = global.selected;
                global.selected = viewer.state.elements[viewer.state.selectedElementIdx];
                all.viewerId(global.selected).forEach(function (viewer) {
                  return viewer.appearance.doSetLight('selected');
                });
              }

              break;

            case 'KeyValueLayout':
              if (message.key === 'ArrowRight') {
                viewer.state.doSelectValue();
              }

              if (message.key === 'ArrowLeft') {
                viewer.state.doSelectKey();
              }

              if (message.key === 'ArrowUp') {
                viewer.state.doIncrementEntry(-1);
              }

              if (message.key === 'ArrowDown') {
                viewer.state.doIncrementEntry();
              }

              if (message.key === 'Enter') {
                viewer.appearance.doSetLight('normal');
                global.prevSelected = global.selected;
                global.selected = viewer.state.entries[viewer.state.selectedEntryIdx][viewer.state.selectedEntryType];
                all.viewerId(global.selected).forEach(function (viewer) {
                  return viewer.appearance.doSetLight('selected');
                });
              }

              break;

            case 'FlowLayout':
              if (message.key === 'ArrowRight') {
                viewer.state.doIncrementElement();
              }

              if (message.key === 'ArrowLeft') {
                viewer.state.doIncrementElement(-1);
              }

              if (message.key === 'Enter') {
                viewer.appearance.doSetLight('normal');
                global.prevSelected = global.selected;
                global.selected = viewer.state.elements[viewer.state.selectedElementIdx];
                all.viewerId(global.selected).forEach(function (viewer) {
                  return viewer.appearance.doSetLight('selected');
                });
              }

              break;

            case 'GridLayout':
              if (message.key === 'ArrowUp') {
                viewer.state.doSelectNeighborCell('north');
              }

              if (message.key === 'ArrowDown') {
                viewer.state.doSelectNeighborCell('south');
              }

              if (message.key === 'ArrowLeft') {
                viewer.state.doSelectNeighborCell('west');
              }

              if (message.key === 'ArrowRight') {
                viewer.state.doSelectNeighborCell('east');
              }

              if (message.key === 'Enter') {
                viewer.appearance.doSetLight('normal');
                global.prevSelected = global.selected;
                global.selected = viewer.state.cells[viewer.state.selectedCellIdx];
                all.viewerId(global.selected).forEach(function (viewer) {
                  return viewer.appearance.doSetLight('selected');
                });
              }

              break;
          }
        });
      });
    }
    /**
     * Dequeues an `Event` from `this.eventQueue` and fires all handler functions for that `Event`. */

  }, {
    key: "_processNextEvent",
    value: function _processNextEvent() {
      var _this29 = this;

      this._isProcessingEvent = true;

      var curr = this._eventQueue.shift();

      if (!curr) {
        this._isProcessingEvent = false;
        return;
      }

      var topic = curr.topic,
          message = curr.message;

      if (topic in this._handlers) {
        this._handlers[topic].forEach(function (handler) {
          return handler(new ViewerSelector(_.values(_this29._viewers).map(function (handleFactory) {
            return handleFactory();
          })), message, _this29._global);
        });
      }

      this._isProcessingEvent = false;

      if (this._eventQueue.length > 0) {
        this._processNextEvent();
      }
    }
  }]);

  return InteractionManager;
}();

var InteractionContext = createContext({
  registerViewer: function registerViewer() {},
  unregisterViewer: function unregisterViewer() {},
  emit: function emit() {}
});

var InteractionProvider =
/*#__PURE__*/
function (_PureComponent13) {
  _inherits(InteractionProvider, _PureComponent13);

  function InteractionProvider() {
    _classCallCheck(this, InteractionProvider);

    return _possibleConstructorReturn(this, _getPrototypeOf(InteractionProvider).apply(this, arguments));
  }

  _createClass(InteractionProvider, [{
    key: "render",
    value: function render() {
      var _this$props19 = this.props,
          children = _this$props19.children,
          manager = _this$props19.manager;
      var registerViewer = manager.registerViewer,
          unregisterViewer = manager.unregisterViewer,
          emit = manager.emit;
      return createElement(InteractionContext.Provider, {
        value: {
          registerViewer: registerViewer,
          unregisterViewer: unregisterViewer,
          emit: emit
        }
      }, children);
    }
  }]);

  return InteractionProvider;
}(PureComponent);

var FlowLayout =
/*#__PURE__*/
function (_PureComponent14) {
  _inherits(FlowLayout, _PureComponent14);

  function FlowLayout(props) {
    var _this30;

    _classCallCheck(this, FlowLayout);

    _this30 = _possibleConstructorReturn(this, _getPrototypeOf(FlowLayout).call(this, props));
    _this30._childViewers = [];
    _this30._childViewerCallbacks = {};
    _this30.state = {
      selectedElementIdx: 0
    };

    _this30._getChildViewerCallback.bind(_assertThisInitialized(_this30));

    return _this30;
  }

  _createClass(FlowLayout, [{
    key: "_getChildViewerCallback",
    value: function _getChildViewerCallback(idx) {
      var _this31 = this;

      var key = "".concat(idx);

      if (!this._childViewerCallbacks[key]) {
        this._childViewerCallbacks[key] = function (viewer) {
          return _this31._childViewers[idx] = viewer;
        };
      }

      return this._childViewerCallbacks[key];
    }
  }, {
    key: "getHandle",
    value: function getHandle() {
      var _this32 = this;

      var selectedElementIdx = this.state.selectedElementIdx;
      return {
        elements: this._childViewers.map(function (viewer) {
          return viewer.viewerId;
        }),
        selectedElementIdx: selectedElementIdx,
        doSelectElement: function doSelectElement(idx) {
          _this32.setState({
            selectedElementIdx: idx
          });
        },
        doIncrementElement: function doIncrementElement() {
          var delta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
          var elements = _this32.props.elements;

          _this32.setState(function (state) {
            var elementIdx = state.selectedElementIdx + delta; // Ensure wrapping to valid array index.

            elementIdx = (elementIdx % elements.length + elements.length) % elements.length;
            return {
              selectedElementIdx: elementIdx
            };
          });
        }
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props$interacti6 = this.props.interactions,
          viewerId = _this$props$interacti6.viewerId,
          emit = _this$props$interacti6.emit;
      var selectedElementIdx = this.state.selectedElementIdx;

      if (selectedElementIdx !== prevState.selectedElementIdx) {
        emit('Flow.DidSelectElement', {
          viewerId: viewerId,
          selectedElementIdx: selectedElementIdx,
          prevSelectedElementIdx: prevState.selectedElementIdx
        });
      }
    }
    /**
     * Renders a sequence of `Viewer` elements, optionally numbered with indices. The sequence can
     * have start/end motifs, which are large characters that can be used to indicate a type of
     * sequence (e.g. "{" for sets).
     */

  }, {
    key: "render",
    value: function render() {
      var _this33 = this;

      var _this$props20 = this.props,
          classes = _this$props20.classes,
          passdown = _this$props20.passdown,
          interactions = _this$props20.interactions,
          light = _this$props20.light;
      var mouseHandlers = interactions.mouseHandlers;
      var elements = this.props.elements;
      return createElement(Frame$1, {
        component: 'div',
        style: 'framed',
        light: light,
        mouseHandlers: mouseHandlers
      }, elements.map(function (fragmentId, idx) {
        return createElement(Fragment, {
          key: "".concat(idx, "-").concat(fragmentId)
        }, createElement(Viewer, Object.assign({
          ref: _this33._getChildViewerCallback(idx),
          key: "".concat(idx, "-").concat(fragmentId)
        }, passdown, {
          fragmentId: fragmentId
        })), idx < elements.length - 1 ? createElement("span", {
          className: classes.spacer
        }) : null);
      }));
    }
  }]);

  return FlowLayout;
}(PureComponent);

var styles$d = function styles$d(theme) {
  return createStyles({
    spacer: {
      marginRight: theme.vars.slot.spacing
    }
  });
};

var FlowLayout$1 = withStyles(styles$d, {
  defaultTheme: defaultTheme
})(FlowLayout);

var Viewer =
/*#__PURE__*/
function (_PureComponent15) {
  _inherits(Viewer, _PureComponent15);

  function Viewer(props) {
    var _this34;

    _classCallCheck(this, Viewer);

    _this34 = _possibleConstructorReturn(this, _getPrototypeOf(Viewer).call(this, props));
    /** Ref to the `Fragment` component that this `Viewer` renders. The specific component used
     * is determined at runtime, so the `any` workaround is needed. */

    _this34._childFragmentRef = createRef();
    _this34.state = {
      bypassedCycle: false,
      light: 'normal'
    };
    _this34.viewerId = cuid();
    return _this34;
  }

  _createClass(Viewer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this35 = this;

      this.context.registerViewer(this.viewerId, function () {
        return _this35._getHandle();
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.context.unregisterViewer(this.viewerId);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var light = this.state.light;
      var emit = this.context.emit;
      var viewerId = this.viewerId;

      if (light !== prevState.light) {
        emit('Viewer.DidChangeLight', {
          viewerId: viewerId,
          light: light
        });
      }
    }
  }, {
    key: "_getFragmentId",
    value: function _getFragmentId() {
      var _this$props21 = this.props,
          view = _this$props21.view,
          fragmentId = _this$props21.fragmentId;
      return fragmentId || view.rootId;
    }
  }, {
    key: "_getFragment",
    value: function _getFragment() {
      var view = this.props.view;
      return view.fragments[this._getFragmentId()];
    }
  }, {
    key: "_getHandle",
    value: function _getHandle() {
      var _this36 = this;

      var parentId = this.props.parentId;
      var light = this.state.light;

      var fragment = this._getFragment();

      return {
        viewerId: this.viewerId,
        parentId: parentId,
        fragmentId: this._getFragmentId(),
        meta: fragment.meta,
        appearance: {
          light: light,
          doSetLight: function doSetLight(l) {
            return _this36.setState({
              light: l
            });
          }
        },
        type: fragment.type,
        contents: fragment.contents,
        state: this._childFragmentRef.current.getHandle()
      };
    }
    /**
     * Returns `true` if this `Viewer` is rendering the same `Fragment` as one of its ancestors.
     * @returns {boolean}
     * @private
     */

  }, {
    key: "_isCycle",
    value: function _isCycle() {
      // let { parentHandle: parent } = this.props;
      // const fragmentId = this._getFragmentId();
      // while (parent) {
      //     if (parent.fragmentId === fragmentId) {
      //         return true;
      //     }
      //     parent = parent.parent;
      // }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this37 = this;

      var _this$props22 = this.props,
          view = _this$props22.view,
          fragmentId = _this$props22.fragmentId;
      var emit = this.context.emit;
      var _this$state5 = this.state,
          bypassedCycle = _this$state5.bypassedCycle,
          light = _this$state5.light;
      var viewerId = this.viewerId; // Explicitly specified fragment for current viewer, or root-level fragment by default.

      var fragment = this._getFragment();

      if (!fragment) {
        console.error('Invalid FragmentId within View: ', fragmentId, view);
        return null;
      }

      if (this._isCycle() && !bypassedCycle) {
        // TODO: once we can compile and test stuff, make this button pretty
        return createElement(Button, {
          onClick: function onClick() {
            return _this37.setState({
              bypassedCycle: true
            });
          }
        }, "...");
      }

      var passdown = {
        view: view,
        parentId: viewerId
      };
      var interactions = {
        viewerId: viewerId,
        emit: emit,
        mouseHandlers: {
          onClick: function onClick(e) {
            e.stopPropagation();
            emit('Viewer.DidClick', {
              viewerId: viewerId
            });
          },
          onDoubleClick: function onDoubleClick(e) {
            e.stopPropagation();
            emit('Viewer.DidDoubleClick', {
              viewerId: viewerId
            });
          },
          onMouseOver: function onMouseOver(e) {
            e.stopPropagation();
            emit('Viewer.DidMouseOver', {
              viewerId: viewerId
            });
          },
          onMouseOut: function onMouseOut(e) {
            e.stopPropagation();
            emit('Viewer.DidMouseOut', {
              viewerId: viewerId
            });
          }
        }
      };
      var props = Object.assign({
        ref: this._childFragmentRef,
        interactions: interactions,
        passdown: passdown,
        light: light
      }, fragment.contents); // The `Viewer` is the component that knows how to dispatch on fragment type to render
      // different primitive and layout components.

      switch (fragment.type) {
        // =====================================================================================
        // Primitives
        case 'TextPrimitive':
          {
            return createElement(TextPrimitive$1, Object.assign({}, props));
          }

        case 'TokenPrimitive':
          {
            return createElement(TokenPrimitive$1, Object.assign({}, props));
          }

        case 'IconPrimitive':
          {
            return createElement(IconPrimitive$1, Object.assign({}, props));
          }

        case 'ImagePrimitive':
          {
            return createElement(ImagePrimitive$1, Object.assign({}, props));
          }
        // =====================================================================================
        // Layouts

        case 'FlowLayout':
          {
            return createElement(FlowLayout$1, Object.assign({}, props));
          }

        case 'SwitchLayout':
          {
            return createElement(SwitchLayout$1, Object.assign({}, props));
          }

        case 'GridLayout':
          {
            return createElement(GridLayout$1, Object.assign({}, props));
          }

        case 'SequenceLayout':
          {
            return createElement(SequenceLayout$1, Object.assign({}, props));
          }

        case 'KeyValueLayout':
          {
            return createElement(KeyValueLayout$1, Object.assign({}, props));
          }

        case 'DagLayout':
          {
            return createElement(DagLayout$1, Object.assign({}, props));
          }

        default:
          {
            console.error("Unknown Fragment type \"".concat(fragment.type, "\" passed to Viewer ").concat(this.viewerId));
            return null;
          }
      }
    }
  }]);

  return Viewer;
}(PureComponent);

Viewer.contextType = InteractionContext;
/**
 * A `Viewer` is used to render a `View`, conforming to the schema in `@vizstack/schema`, which has
 * been constructed manually or produced through language bindings. For convenience, it is
 * possible to pass the `@vizstack/js` bindings directly to the `Viewer`.
 * @example
 * ```
 * // JS-bindings input
 * <Viewer view={Text('Hello, world!')} />
 *
 * // Schema input
 * <Viewer view={{
 *     rootId: 'root',
 *     fragments: {
 *       root: {
 *         type: 'TextPrimitive',
 *         contents: { text: 'Hello, world!' },
 *         meta: {},
 *       }
 *     }
 *   }} />
 * ```
 */

var ViewerRoot = forwardRef(function (props, ref) {
  var view = props.view,
      fragmentId = props.fragmentId;
  var schematized = view instanceof FragmentAssembler ? assemble(view) : view;
  return createElement(Viewer, {
    view: schematized,
    fragmentId: fragmentId || schematized.rootId,
    ref: ref
  });
});
export { InteractionManager, InteractionProvider, LightTheme, ViewerRoot as Viewer };